var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkills10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "es3kTfY9O2J1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170 160",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "0f03fd5c0c2c47c392b6f9f7de1c85f4",
    "export-id": "d203d80d445a43328b43402105661b10",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J6-fill",
    x1: 2005.54,
    y1: 824.553,
    x2: 2050.802,
    y2: 824.553,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J6-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J6-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J7-fill",
    x1: 2011.55,
    y1: 793.585,
    x2: 2045.501,
    y2: 793.585,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J7-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J7-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J8-fill",
    x1: 2011.69,
    y1: 793.585,
    x2: 2045.242,
    y2: 793.585,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J8-fill-0",
    offset: "32.5%",
    stopColor: "#d45652"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J8-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J9-fill",
    x1: 2000.11,
    y1: 749.39,
    x2: 2056.959,
    y2: 749.39,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J9-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J9-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J10-fill",
    x1: 2008.27,
    y1: 774.691,
    x2: 2018.575,
    y2: 774.691,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J10-fill-0",
    offset: "32.5%",
    stopColor: "#d45652"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J10-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J11-fill",
    x1: 2045.52,
    y1: 789.41,
    x2: 2053.441,
    y2: 789.41,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J11-fill-0",
    offset: "32.5%",
    stopColor: "#d45652"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J11-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J19-fill",
    x1: 2016.27,
    y1: 806.089,
    x2: 2023.665,
    y2: 806.089,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J19-fill-0",
    offset: "32.5%",
    stopColor: "#d45652"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J19-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J42-fill",
    x1: 1752.64,
    y1: 774.607,
    x2: 1770.756,
    y2: 774.607,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J42-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J42-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J43-fill",
    x1: 1880.45,
    y1: 788.087,
    x2: 1908.743,
    y2: 788.087,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J43-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J43-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J44-fill",
    x1: 1784.68,
    y1: 841.607,
    x2: 1799.24,
    y2: 841.607,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J44-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J44-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J45-fill",
    x1: 1866.26,
    y1: 781.018,
    x2: 1889.523,
    y2: 781.018,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J45-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J45-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J46-fill",
    x1: 1789.16,
    y1: 839.437,
    x2: 1803.72,
    y2: 839.437,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J46-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J46-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J47-fill",
    x1: 1785.89,
    y1: 848.473,
    x2: 1833.9,
    y2: 848.473,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J47-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J47-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J48-fill",
    x1: 1793.09,
    y1: 848.847,
    x2: 1827.765,
    y2: 848.847,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J48-fill-0",
    offset: "32.5%",
    stopColor: "#d45652"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J48-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J50-fill",
    x1: 1815.95,
    y1: 852.839,
    x2: 1822.288,
    y2: 852.839,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J50-fill-0",
    offset: "32.5%",
    stopColor: "#d45652"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J50-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J54-fill",
    x1: 2005.54,
    y1: 824.553,
    x2: 2050.802,
    y2: 824.553,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J54-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J54-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J83-fill",
    x1: 1906.98,
    y1: 853.666,
    x2: 1953.351,
    y2: 853.666,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J83-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J83-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J84-fill",
    x1: 1806.21,
    y1: 1003.27,
    x2: 1734.826,
    y2: 1021.607,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J84-fill-0",
    offset: "0%",
    stopColor: "#d25a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J84-fill-1",
    offset: "69.1%",
    stopColor: "#b04a4b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J87-fill",
    x1: 1642.38,
    y1: 821.315,
    x2: 1643.78,
    y2: 789.413,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J87-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J87-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J88-fill",
    x1: 1545.06,
    y1: 812.092,
    x2: 1616.084,
    y2: 929.992,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J88-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J88-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J90-fill",
    x1: 1592.32,
    y1: 832.693,
    x2: 1625.628,
    y2: 733.196,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J90-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J90-fill-1",
    offset: "86%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J92-fill",
    x1: 1661.49,
    y1: 822.86,
    x2: 1667.293,
    y2: 794.931,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J92-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J92-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J95-fill",
    x1: 1687.84,
    y1: 806.133,
    x2: 1692.621,
    y2: 783.121,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J95-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J95-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J98-fill",
    x1: 1694.92,
    y1: 828.094,
    x2: 1700.066,
    y2: 803.254,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J98-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J98-fill-1",
    offset: "85.6%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J99-fill",
    x1: 1739.22,
    y1: 812.504,
    x2: 1719.12,
    y2: 861.734,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J99-fill-0",
    offset: "32.5%",
    stopColor: "#d45652"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J99-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J100-fill",
    x1: 1634.37,
    y1: 810.068,
    x2: 1634.195,
    y2: 783.527,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J100-fill-0",
    offset: "12.8%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J100-fill-1",
    offset: "52.9%",
    stopColor: "#ed956e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J102-fill",
    x1: 1714.58,
    y1: 766.586,
    x2: 1698.831,
    y2: 799.593,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J102-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J102-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J103-fill",
    x1: 1683.51,
    y1: 778.371,
    x2: 1674.404,
    y2: 795.677,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J103-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J103-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J114-fill",
    x1: 1683.62,
    y1: 789.694,
    x2: 1680.666,
    y2: 803.297,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J114-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J114-fill-1",
    offset: "99.5%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J123-fill",
    x1: 1710.23,
    y1: 781.989,
    x2: 1707.746,
    y2: 793.43,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J123-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J123-fill-1",
    offset: "99.5%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J127-fill",
    x1: 1644.98,
    y1: 811.792,
    x2: 1654.227,
    y2: 793.629,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J127-fill-0",
    offset: "1.9%",
    stopColor: "#d65764"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J127-fill-1",
    offset: "63%",
    stopColor: "#ffc6a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J130-fill",
    x1: 1688.69,
    y1: 741.931,
    x2: 1659.159,
    y2: 741.931,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J130-fill-0",
    offset: "5.6%",
    stopColor: "#ffddc9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J130-fill-1",
    offset: "77.1%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J135-fill",
    x1: 1696.47,
    y1: 813.341,
    x2: 1706.544,
    y2: 826.442,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J135-fill-0",
    offset: "4%",
    stopColor: "#b22842"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J135-fill-1",
    offset: "21.3%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J135-fill-2",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J136-fill",
    x1: 1686.69,
    y1: 813.146,
    x2: 1689.369,
    y2: 812.641,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J136-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J136-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J138-fill",
    x1: 1693.93,
    y1: 811.07,
    x2: 1700.571,
    y2: 819.707,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J138-fill-0",
    offset: "4%",
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J138-fill-1",
    offset: "99.5%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J139-fill",
    x1: 1725.91,
    y1: 992.46,
    x2: 1622.833,
    y2: 981.007,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J139-fill-0",
    offset: "0%",
    stopColor: "#d25a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J139-fill-1",
    offset: "69.1%",
    stopColor: "#b04a4b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J142-fill",
    x1: 1915.59,
    y1: 820.303,
    x2: 1944.886,
    y2: 820.303,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J142-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J142-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J143-fill",
    x1: 1912.42,
    y1: 820.558,
    x2: 1943.131,
    y2: 820.558,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J143-fill-0",
    offset: "32.5%",
    stopColor: "#d45652"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J143-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J144-fill",
    x1: 1902.47,
    y1: 784.009,
    x2: 1948.509,
    y2: 784.009,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J144-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J144-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J149-fill",
    x1: 1909.28,
    y1: 806.113,
    x2: 1919.173,
    y2: 806.113,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J149-fill-0",
    offset: "32.5%",
    stopColor: "#d45652"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J149-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J164-fill",
    x1: 1941.52,
    y1: 816.769,
    x2: 1953.777,
    y2: 816.769,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J164-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J164-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J165-fill",
    x1: 1944.01,
    y1: 820.414,
    x2: 1950.348,
    y2: 820.414,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J165-fill-0",
    offset: "32.5%",
    stopColor: "#d45652"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J165-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J202-fill",
    x1: 2055.39,
    y1: 940.361,
    x2: 2086.64,
    y2: 940.361,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J202-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J202-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J204-fill",
    x1: 2056.49,
    y1: 952.553,
    x2: 2061.386,
    y2: 952.553,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J204-fill-0",
    offset: "32.5%",
    stopColor: "#d45652"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J204-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J206-fill",
    x1: 2059.6,
    y1: 959.365,
    x2: 2064.736,
    y2: 959.365,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J206-fill-0",
    offset: "32.5%",
    stopColor: "#d45652"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J206-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J207-fill",
    x1: 2058.67,
    y1: 936.611,
    x2: 2074.717,
    y2: 931.835,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J207-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J207-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J313-fill",
    x1: 1785.37,
    y1: 846.376,
    x2: 1800.679,
    y2: 846.376,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J313-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J313-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J314-fill",
    x1: 1871.73,
    y1: 774.248,
    x2: 1892.373,
    y2: 774.248,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J314-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J314-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J315-fill",
    x1: 1869.77,
    y1: 779.65,
    x2: 1882.169,
    y2: 779.65,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J315-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J315-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J316-fill",
    x1: 1865.94,
    y1: 787.801,
    x2: 1876.688,
    y2: 787.801,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J316-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J316-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J317-fill",
    x1: 1867.54,
    y1: 783.516,
    x2: 1880.027,
    y2: 783.516,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J317-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J317-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J318-fill",
    x1: 1738.55,
    y1: 776.741,
    x2: 1780.803,
    y2: 776.741,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J318-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J318-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J320-fill",
    x1: 1868.33,
    y1: 787.362,
    x2: 1874.128,
    y2: 787.362,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J320-fill-0",
    offset: "32.5%",
    stopColor: "#d45652"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J320-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J322-fill",
    x1: 1870.59,
    y1: 783.294,
    x2: 1876.206,
    y2: 783.294,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J322-fill-0",
    offset: "32.5%",
    stopColor: "#d45652"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J322-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J323-fill",
    x1: 1745.9,
    y1: 912.919,
    x2: 1659.382,
    y2: 944.841,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J323-fill-0",
    offset: "0%",
    stopColor: "#d25a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J323-fill-1",
    offset: "69.1%",
    stopColor: "#b04a4b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J327-fill",
    x1: 1773.87,
    y1: 780.556,
    x2: 1778.311,
    y2: 780.556,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J327-fill-0",
    offset: "32.5%",
    stopColor: "#d45652"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J327-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "es3kTfY9O2J329-fill",
    x1: 1774.6,
    y1: 786.614,
    x2: 1779.04,
    y2: 786.614,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J329-fill-0",
    offset: "32.5%",
    stopColor: "#d45652"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "es3kTfY9O2J329-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.269636 0 0 0.538199 569.375293-347.533025)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2069.7,762.3c.4-6.8-2.9-13.1-7.2-14.8-3.1-1.3-6-.1-9,1.6-3.4,1.8-27.2.2-29.1,3.5s6.2,10.5,5.2,14.1c-1.3,4.6,11,5.4,10.2,10.1-.7,3.5-1.1,7.3.7,10.1c1.9,2.9-1.4,21.4,2.2,20.2c0,0,12.4,2.2,21.7-21.7c3-7.9,4.9-17,5.3-23.1Z",
    fill: "#f8d5a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.5,827c0,0,6.4,8.6,20.8,9.3c14.5.7,24.5-7.7,24.5-7.7s-3.7-2.1-21.7-3.8c-14.5-1.3-23.6,2.2-23.6,2.2Z",
    fill: "url(#es3kTfY9O2J6-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2016.3,799.5l16.1-5.9l13.1.9c-.7,4.5-4,26-2.7,34.2-11.8,5.3-22.2,5.3-31.2-2.1.5-6.5,2.2-23.1,2.1-25.5l2.6-1.6Z",
    fill: "url(#es3kTfY9O2J7-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2037,793.9l-4.6-.3-16.1,5.9-2.6,1.6c.1,2.2-1.4,16.5-2,23.8c2.3,1.2,6.1,2.1,12.6,1.3c8.7-1,14.8-5.1,18.5-8.9.5-7.9,1.8-16.8,2.4-21.1l-8.2-2.3Z",
    fill: "url(#es3kTfY9O2J8-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2048.6,787.5c-5.4-1.2-5.6-8.5-3.4-13.3c0,0-8.8-7-5.5-17.6-8-7.4-32.9-12.8-36,3-5.3,26.4-3.9,41.6-1.3,49.3c2.7,8.1,12.8,12.6,23.1,9.6c6.8-2,12.9-4.2,17.4-18.1c5.1,2.2,9.8-.9,12.6-5.4c4.9-9.9-3.8-10.7-6.9-7.5Z",
    fill: "url(#es3kTfY9O2J9-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2017.7,775.2c0,0,.6,1.7.8,4.4q.1,1.1,0,2.3c0,.4-.1.8-.2,1.3-.1.4-.1.7-.3,1.2-.6,1.8-1.6,3.4-2.7,4.9-1.2,1.4-2.6,2.7-3.7,3.8-.3.2-.6.5-.7.7c0,0,0,.1,0,0c.1-.1.1-.3.1-.4c0,.3-.1-.2,0,0s.6.7,1,1c1,.6,1.9.9,2.5,1.1.7.2,1.1.4,1.1.4.5.1.8.7.6,1.2-.1.4-.5.6-.9.6c0,0-.5.1-1.3,0s-2-.4-3.3-1.1c-.7-.4-1.4-.8-2-1.8-.2-.1-.5-1.1-.4-1-.1-.4,0-.7.2-1.1.1-.2.1-.3.2-.4.4-.5.7-.8,1-1.1c1.3-1.1,2.5-2.3,3.6-3.5s2-2.7,2.5-3.9c.2-.3.3-.8.4-1.1s.1-.7.2-1q.1-1,.1-1.9c0-1.3-.1-2.3-.2-3-.1-.8-.2-1.2-.2-1.2c0-.4.3-.8.7-.9s.8.2.9.5Z",
    fill: "url(#es3kTfY9O2J10-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2046.9,792.1c-1.7,2.1-1.8,4.6-.4,5.5s3.9-.2,5.6-2.4c1.6-2.1,1.8-4.6.4-5.5-1.5-.9-4,.2-5.6,2.4Z",
    fill: "url(#es3kTfY9O2J11-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2013.3,771.1c-.3,1.6-3.5,1.5-6.7,1.6-4.8.3-6,.2-6.3-1.1-.2-.6.3-3.5,5.5-4c6.1-.4,7.8,2,7.5,3.5Z",
    fill: "#f8d5a6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2030.7,776c3.5,1.3,6,2.8,7.1,1.6.9-.9.6-3.7-4.8-6.3-3-1.4-8-2.1-8.9.6-.8,2.5,3.1,2.9,6.6,4.1Z",
    fill: "#f8d5a6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2013.6,805.5c-1.5,0-2.8-.3-3.3-.7-.4-.2-.5-.7-.2-1c.2-.3.7-.4,1-.2c1.4,1,10.7.5,14.8-4.8.2-.3.7-.4,1-.1.3.2.4.7.2,1-3.3,4.3-9.5,5.8-13.5,5.8Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2023.6,806.3c.2.8-.6,2.6-2.8,3.2-2.3.7-4.3-.3-4.5-1-.2-.8,1.6-.5,3.6-1.1s3.5-1.8,3.7-1.1Z",
    fill: "url(#es3kTfY9O2J19-fill)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2032.9,781.8c.6.3-1.7,4.5-6.4,3.4-3.5-.9-3.2-3.6-2.7-3.8s1.2,1.3,3.1,1.9c2.5.7,5.5-1.9,6-1.5Z",
    fill: "#625153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2012.1,778.8c.9.7-1.6,4.4-5.5,3.4-3.5-.8-3.3-4.1-2.7-4.1.6-.1.5,1.8,3.1,2.3c2.9.6,4.6-2,5.1-1.6Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2040.2,756.6c0,0-11.9,4.4-25.5,1.5-18-4-20.7-14.8-20.7-14.8l4.1.7-1.9-4.2c0,0,6.2-.1,13.5-2.7c5.6-1.9,16.4-8.8,32.3-6.4c18.3,2.7,18.8,16.7,18.8,16.7s-8.9,7-20.6,9.2Z",
    fill: "#f8d5a6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2056.9,777.8q-.1,0-.2,0c-.2,0-4.5-1-8.6-4.3-2.4-1.9-5.2-5.2-5.6-9-.1-.4.2-.8.7-.9.4,0,.8.3.9.7.3,2.7,2.3,5.8,5,7.9c3.8,3.1,7.9,4,7.9,4c.5.1.8.5.7,1-.1.3-.4.6-.8.6Z",
    fill: "#edc08d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2055,782.1q-.1,0-.1,0c-2.6-.3-5.2-1.5-7.1-3.4-.3-.4-.3-.9,0-1.2.4-.3.9-.3,1.2,0c1.6,1.7,3.8,2.7,6.1,2.9.4.1.7.5.7.9c0,.5-.4.8-.8.8Z",
    fill: "#edc08d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2025.6,756.4c-8.6,0-17.2-2.6-24.2-7.6-.4-.2-.5-.7-.2-1.1s.8-.5,1.1-.2c11,7.8,26.2,9.5,38.6,4.2.4-.1.9.1,1.1.5s0,.9-.5,1.1c-5,2.1-10.4,3.1-15.9,3.1Z",
    fill: "#edc08d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2011.8,749.6q-.1,0-.2,0c-4.4-1.4-8.5-3.7-11.9-6.8-.3-.3-.3-.8,0-1.2.3-.3.8-.3,1.1,0c3.3,2.9,7.2,5.1,11.3,6.4.4.2.7.6.5,1.1-.1.3-.4.5-.8.5Z",
    fill: "#edc08d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2057.5,747.7c-.4,0-.8-.4-.8-.8c0-.3-.4-6.7-8.5-10.6-8.4-3.9-16.8-2.3-16.9-2.3-.4.1-.9-.2-1-.7-.1-.4.2-.8.7-.9.3-.1,9-1.7,17.9,2.5c9,4.2,9.4,11.6,9.4,11.9c0,.5-.3.9-.8.9q0,0,0,0Z",
    fill: "#edc08d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2066.3,767.1q-.2,0-.3,0c-.4-.2-.7-.6-.5-1.1c0,0,1.2-3.7.2-9.4-1-5.5-6.6-7-6.8-7.1-.5-.1-.7-.5-.6-1c.1-.4.5-.7,1-.6.2.1,6.8,1.9,8,8.4c1.1,6.1-.2,10.1-.3,10.3-.1.3-.4.5-.7.5Z",
    fill: "#edc08d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2054.1,748.5q-.1,0-.1,0c-.5-.1-.8-.5-.8-.9c0-.2.3-3.6-3.7-6.2-.4-.2-.5-.7-.2-1.1.2-.4.7-.5,1.1-.2c4.9,3.1,4.5,7.5,4.5,7.6-.1.5-.4.8-.8.8Z",
    fill: "#edc08d"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.318389 0 0 0.473292-515.149366-304.352868)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.140812 6.338583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1752.6,784c3.1-3.1,6.6-7,9.6-8.5c2.3-1.1,7.5-1.8,8.5,1.5c1,3.2-18.1,7-18.1,7Z",
    fill: "url(#es3kTfY9O2J42-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1891.4,788.1c3.3,5.5,17.3,15.2,17.3,15.2l-15.5,16.8c0,0-8.6-14.6-12.7-17.1c0,0,2.4-5.1,5-8.8c2.5-3.7,5.9-6.1,5.9-6.1Z",
    fill: "url(#es3kTfY9O2J43-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790.6,850.7c-3.7-3.5-7.4-7.9-5.3-8.9s3.8,1.5,7.2,4.6c3.4,3,6.7,4.6,6.7,4.6l-3.9,2.2-4.7-2.5Z",
    fill: "url(#es3kTfY9O2J44-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1866.3,790.6c1,3.2,11.9,12.8,16.4,12.9c4.5.2,7.5-5.4,6.7-8.3-3.3-12-18.1-14.2-18.1-14.2l-.1,5.7-4.9,3.9Z",
    fill: "url(#es3kTfY9O2J45-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795,848.5c-3.6-3.5-7.4-7.8-5.2-8.8c2.1-1,3.8,1.4,7.2,4.5c3.3,3.1,6.7,4.6,6.7,4.6l-3.9,2.2-4.8-2.5Z",
    fill: "url(#es3kTfY9O2J46-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.1,848.5c-1.4.5,6,7.8,12,10.3c6,2.4,12.1,1.3,14.2,3.2c2.2,1.9,6.7,12,6.7,12l14.9-9.5c0,0-7.9-10.9-13.6-13.3-5.7-2.5-34.2-2.7-34.2-2.7Z",
    fill: "url(#es3kTfY9O2J47-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1822.9,855.9c2,.3,3.6.8,4.9,1.2-2.4-2.5-5.1-4.9-7.4-5.9l-13.2-1.9c-2.5-.2-5.1-.3-7.6-.5l-6.5,1.2c2.3,1.5,1.8,1.5,8.4,2.8c6.6,1.4,16.1,2.3,21.4,3.1Z",
    fill: "url(#es3kTfY9O2J48-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1821.7,858.1c-.3,0-.5-.1-.6-.3-1.1-1.7-2.8-3-4.7-3.7-.4-.1-.5-.5-.4-.8.1-.4.5-.5.8-.4c2.2.8,4.1,2.3,5.4,4.2.2.3.1.7-.2.9q-.2.1-.3.1Z",
    fill: "url(#es3kTfY9O2J50-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1982.9,832.9c-12.3,4.4-33.7,11.6-33.7,11.6s-28.9-38.7-48.8-51.3c0,0-13,9.4-15.5,19.8c0,0,23.8,52.5,48.4,66.9c19.9,11.7,52.1-1.1,52.1-1.1l-2.5-45.9Z",
    fill: "#a8c7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2050.8,828.6c12.8,4.1,26.8,9.7,26.8,9.7s-10.5,50.8-11,69.6c-.6,18.7-1.4,65.3-1.4,65.3h-87.3c0,0-2.6-72.9-2.4-90.3.2-24.4,8.9-49.6,8.9-49.6l21.1-6.3l45.3,1.6Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2001.3,832.1l-1.8,3.4c0,0,6.1,5.6,18.1,7.7c11.9,2.2,20,.8,20,.8l.6-5.1-36.9-6.8Z",
    fill: "#d4bfb9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2005.5,827c0,0,6.4,8.6,20.8,9.3c14.5.7,24.5-7.7,24.5-7.7s-3.7-2.1-21.7-3.8c-14.5-1.3-23.6,2.2-23.6,2.2Z",
    fill: "url(#es3kTfY9O2J54-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2042.4,826.2c0,0-14,18.7-16.1,53.2-1.9,29.9-.1,71.6-1.2,93.8h41.7c0,0-.2-35.8.6-57.5s10.2-77.4,10.2-77.4-13.5-7.7-35.2-12.1Z",
    fill: "#a8c7bf"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2025.1,973.5q0,0-.1,0c-.4,0-.8-.4-.7-.9.4-9.6.4-23,.3-37.2-.1-18.3-.2-39.1.8-56.1c2.2-34.3,16.2-53.4,16.4-53.6.3-.3.8-.4,1.1-.1.4.3.5.8.2,1.1-.2.2-13.9,18.9-16,52.7-1.1,16.9-1,37.7-.9,56c.1,14.2.2,27.6-.3,37.3c0,.4-.4.8-.8.8Z",
    fill: "#90b3ad"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2066.8,973.5c-.4,0-.8-.4-.8-.8s-.2-35.5.6-57c.5-12.9,3.9-37.7,6.8-56.2.1-.5.5-.8.9-.7.5.1.8.5.7.9-2.8,18.5-6.3,43.2-6.8,56.1-.8,21.4-.5,56.5-.5,56.9s-.4.8-.9.8q0,0,0,0Z",
    fill: "#90b3ad"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2005.5,827c0,0-8.5,17.5-12.9,44.3-4.3,26.7-4.7,101.9-4.7,101.9h-20.9c0,0-.8-60,1-85.3c1.9-25.3,14.9-55,14.9-55s12.9-4.1,22.6-5.9Z",
    fill: "#a8c7bf"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1987.9,972.9q0,0,0,0c-.4,0-.8-.3-.8-.8c0-.7.4-74.5,4.7-101s12.9-44.3,13-44.4c.2-.4.7-.6,1.1-.4s.6.7.4,1.1c-.1.2-8.6,17.7-12.9,44-4.2,26.4-4.7,100-4.7,100.7c0,.5-.3.8-.8.8Z",
    fill: "#90b3ad"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2019.9,835.5c0,0,22.6-12,22.8-13.2.2-1.3,0-5.3.4-8.5c0,0,10.2,1.9,14.8,5.4c5.7,4.3,8.5,10.7,8.1,13.3-.3,2.5-26.9,12.9-46.4,8.7-9.4-2,.3-5.7.3-5.7Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2019.9,835.5l-8.1-12.2l1.3-7c0,0-7.7,1.2-10.3,3.2-3.8,2.9-7.5,6.6-7,10s14,9.9,23,11.7c3.3.7,1.1-5.7,1.1-5.7Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1815.8,873.4c0,0,10-9.4,19.7-10.8c0,0,16.4,28.1,24.7,41.8c0,0,14.2-32.8,31.2-42.2l12.3,56.4c0,0-25.6,31.9-44,30.8-16.6-.9-31.6-23.6-43.9-76Z",
    fill: "#625153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1953.9,829.9c2.4,6.3,16,7.2,21.4,10.8s3.2,12.1,3.2,12.1s8,19.2-.5,25.7c-5.3,4-34.2,2.2-39.6-15.2s0-28.6,0-28.6l15.5-4.8Z",
    fill: "#bc6861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1953.4,858.9c8.5,5.1,14.3,10.2,14.3,10.2s-6.5,49.6-6.9,65.9c-.3,16.2,3.3,38.2,3.3,38.2h-77.6c0,0,4-31.1,3.3-37.6-.8-6.5-8.5-27.1-8.7-32.9-.2-5.9,9.8-40.7,10.3-40.5c5.5-3.4,10.6-4.4,15.6-5.9l46.4,2.6Z",
    fill: "#625153"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1930.4,872.4q-2.1,0-4.4-.2c-18.7-1.4-27.5-11.6-27.8-12-.3-.3-.3-.8.1-1.1.3-.3.8-.3,1.1.1.1.1,8.7,10,26.8,11.4s33.5-6.7,33.7-6.8c.4-.2.9,0,1.1.4s0,.9-.3,1.1c-.2.1-13.6,7.1-30.3,7.1Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1902.2,863.4c-.3,0-.6-.2-.7-.5-.2-.4,0-.9.4-1.1l8.3-3.9c.4-.2.9-.1,1.1.3.2.5,0,.9-.4,1.1l-8.3,4q-.2.1-.4.1Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1906.2,866.1c-.2,0-.5-.1-.6-.3-.3-.4-.2-.9.1-1.2l7.5-5.2c.3-.3.8-.2,1.1.2.3.3.2.8-.2,1.1l-7.4,5.3q-.2.1-.5.1Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1918,870.8q-.3,0-.5-.1c-.3-.3-.5-.8-.2-1.1l4.5-7.3c.2-.4.7-.5,1.1-.2.4.2.5.7.3,1.1l-4.5,7.2c-.2.3-.5.4-.7.4Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1932.6,872.1c-.4,0-.8-.4-.8-.8l-.2-7.6c0-.5.4-.8.8-.9.5.1.8.4.8.8l.2,7.6c0,.5-.3.9-.8.9q0,0,0,0Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1937.9,871.5c-.4,0-.8-.3-.9-.7l-1.2-7.7c-.1-.5.2-.9.7-1c.4,0,.8.3.9.7l1.3,7.8c0,.4-.3.8-.7.9q-.1,0-.1,0Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1951.8,868.4c-.3,0-.5-.1-.7-.3l-5.4-6.6c-.3-.4-.2-.9.1-1.2.4-.3.9-.2,1.2.1l5.4,6.7c.3.4.2.9-.1,1.2q-.2.2-.5.1Z",
    fill: "#544548"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1944.9,853.7c1.3,1.4,8.5,5.2,8.5,5.2s-12.4,5.7-25.9,5.1c-13.4-.5-20.5-7.7-20.5-7.7l5.4-1.2l32.5-1.4Z",
    fill: "url(#es3kTfY9O2J83-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1722.5,851.4c19.9,8.3,31.7,19.3,44.1,76.3c7.4,33.5,9.8,51.3,9.8,51.3h-32.7c0,0-5.8-35.1-10.7-55.1-8.8-36.2-10.5-72.5-10.5-72.5Z",
    fill: "url(#es3kTfY9O2J84-fill)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 3718.246919-15.443313)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0-8.451444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1660,802.7q-.1-.1-.1-.1-.1-.1-.2-.1-.5-.3-1.1-.6t-1.2-.6q-.5-.3-1.1-.5-.6-.3-1.2-.5-1.2-.4-2.4-.4-1.3-.1-2.6.1c-1.8.4-2.9,1.6-3.5,3.1-.5,1.5-.5,3.3,0,4.9.9,3,3.8,5.6,7.1,6.9s7,1.2,9.4-1.5q.5-.5.8-1.2.3-.6.3-1.3.2-1.2-.1-2.3t-.8-2.1q-.5-1.2-1.4-2.2-.8-.9-1.9-1.6Z",
    transform: "translate(0 0.000001)",
    fill: "url(#es3kTfY9O2J87-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1649.5,783.9l.1.3.1.3c.7,1.9,1.6,3.7,2.6,5.4.9,1.7,1.9,3.4,2.8,5.2q.8,1.6,1.6,3.3.8,1.6,1.5,3.3.5,1.1,1,2.2.5,1,1,2.1.2.5.4.9t.3.8q.7,1.4,1.3,2.7.6,1.4,1.1,2.7.1.2.2.4q0,.2.1.3.2.4.3.7.2.4.3.7.3.7.6,1.4t.6,1.4q1,2.4,1.9,4.9q1,2.4,1.8,5q.5,1.3.9,2.5.3,1.2.7,2.5q0,0,0,.1t.1.2c.6,2.4,1.1,4.8,1.4,7.4s.3,5.4.1,8.5q0,.3,0,.6-.1.3-.1.6c-.2,1.6-.5,3-.8,4.2-.2,1.2-.5,2.1-.8,2.7q0,.1-.1.3q0,.1,0,.2-.1.2-.2.3q0,.1,0,.1c-.2.9-.3,1.1-.2,1.2s.4.1,1.2.8q0,.1,0,.1.1,0,.1.1c1.9,1.6,4.4,2.8,7.1,3.5c2.7.8,5.6,1.1,8,1q2.1,0,4.1-.4q2.1-.3,4.1-.9c.6-.2,1.3-.6,2-.9.6-.3,1.3-.6,2-.7.6-.1,1.1,0,1.5.1.4.2.9.5,1.4.9q1.5,1.1,2.7,2.4q1.3,1.4,2.3,2.9.1,0,.2.2.1.1.2.2c.4.7,1.2,1.8,1.9,2.8.6,1.1,1.2,2.1,1.4,2.6-.4-.5-.4-2.5-.3-4.8.1-2.4.3-5.1.2-7.1c0-1.5,0-3,.2-4.6.1-1.5.4-3,.9-4.4.3-.7.7-1.2.9-1.8.3-.6.4-1.2.2-1.9-.2-.5-.6-.9-1.1-1.3-.4-.5-.9-.8-1.2-1.2-.7-.8-1.2-1.6-1.8-2.5-.5-.8-.9-1.7-1.4-2.6q-.1-.1-.2-.2q0-.1-.1-.2-.1-.3-.2-.5-.2-.2-.3-.4-.4-.9-.8-1.8-.4-.8-.8-1.7-.3-.7-.6-1.5-.2-.8-.5-1.5q0-.1,0-.1t0,0t0-.1q0,0,0-.1-.1-.1-.1-.2t-.1-.2v-.1-.1q0-.1-.1-.2q0-.1,0-.1c0,0,.5-.1,1-.3s1.2-.5,1.6-.6q.6-.3,1.2-.5.6-.3,1.2-.7l.3-.1.3-.1q0,0,0-.1q0,0,.1,0q.2-.1.3-.2.2-.1.4-.3.1-.1.2-.1.1-.1.2-.2q0-.1.1-.1q0-.1.1-.1.4-.3.6-.5.3-.3.6-.6c.4-.6.7-1.2.9-1.8.3-.6.5-1.3.7-1.9q.5-1.2.9-2.4.5-1.3.8-2.5.7-2.5,1.2-5.1t.8-5.2c.3-2.2.5-4.3.3-6.4-.1-2.1-.7-4.2-1.9-6.2-.8-1.4-1.7-2.8-2.5-4.3s-1.5-3.1-2.1-4.6q-.1-.5-.3-.9-.1-.5-.2-.9q0,0,0-.1-.1-.1-.1-.1-.1-.4-.1-.7-.1-.4-.1-.7q0-.1,0-.1t0,0q-.3-1.6-.5-3.3-.1-1.6-.3-3.2-.1-.3-.1-.7-.1-.3-.1-.7-.2-.8-.4-1.7-.1-.8-.4-1.6-.2-.6-.4-1.2t-.5-1.2c-1-2.1-2.3-4.2-3.8-6.3-1.5-2-3.2-3.9-5.1-5.4q-.4-.3-.7-.6-.3-.2-.7-.5q0,0,0,0t0,0q-.8-.6-1.7-.8-1-.2-2-.1-.4,0-.8.1-.4,0-.9.1-.2,0-.4.1-.2,0-.4.1-.2,0-.5.1-.2.1-.4.1-.3.1-.6.2t-.6.2q-.8.3-1.6.6-.8.2-1.5.4-4,1.2-7.9,2.5-3.9,1.2-7.8,2.6c-2,.7-3.9,1.6-5.7,2.6-1.9,1-3.7,2-5.5,3q-.4.2-.8.4t-.7.4q-.2.2-.4.3-.2.2-.4.3-.2.2-.5.4t-.5.4q-.5.5-1,.9-.5.5-1,1-.7.8-1.3,1.6-.5.8-1,1.7-.2.3-.4.7-.2.3-.4.7c-.4,1.1-.7,1.8-.8,2.6s0,1.6.4,2.7Z",
    fill: "url(#es3kTfY9O2J88-fill)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1698,759.1c-.3.4-.8.9-1.2,1.3-.5.5-.9.9-1.1,1.1q-1.1,1.2-2.4,2.2-1.2,1.1-2.5,2-2.5,1.8-5.1,3.2-2.6,1.5-5.2,2.7c-1.8.8-3.6,1.5-5.4,2.1-1.8.7-3.6,1.3-5.4,1.9-.7.2-1.5.5-2.4.8-.8.3-1.6.7-2.1,1.2-.8.7-1.1,1.5-1.2,2.4-.2,1-.1,1.9-.1,2.8-.1,2.1.2,4.1.7,6.1s1.1,4,1.6,6q1,3.3,2.1,6.5q1.2,3.2,2.7,6.2c2.2,4.5,4.5,8.8,7.6,12.5c3,3.7,6.7,6.8,11.5,8.8q1,.4,1.9.7t1.9.5q3,.8,6.1.9t6.1-.3c.7-.1,1.7-.4,2.5-.7s1.5-.6,1.5-.6q-.2.2-.5.4-.3.3-.8.6-.1,0-.1,0q0,.1-.1.1l-.2.1-.3.1q-.6.4-1.2.6-.6.3-1.2.6c-.5.1-1.1.4-1.6.6s-1,.3-1,.3v.2.2q-.2.1-.3.1-.1.1-.3.2-.2.2-.5.4t-.6.4c0,0-.2.1-.3.2s-.3.3-.2.4c.1.5-.7,1.1-1.5,1.7-.8.5-1.6,1.1-1.4,1.6.2.6-.8.9-1.7,1.3-1,.3-2,.6-1.7,1.2-1.9,1.7-2.8,2.7-3.8,3.6-1,.8-2.1,1.5-4.5,2.5-3.4,1.4-5.2,2.6-7.1,3.3-1.8.7-3.7.8-7,.2q0-.3.1-.6q0-.3,0-.6c.3-3.1.2-5.9-.1-8.5s-.8-5-1.4-7.4q-.1-.1-.1-.2t0-.1q-.3-1.3-.7-2.5-.4-1.3-.8-2.5-1.8-5.3-3.9-10.3t-4.3-10q-.2-.4-.4-.8t-.4-.8q-1.2-2.8-2.4-5.5-1.3-2.8-2.7-5.4c-.9-1.8-1.9-3.5-2.8-5.3-.9-1.7-1.8-3.5-2.5-5.3l-.1-.4-.2-.3c-.3-1-.4-1.8-.3-2.6s.4-1.6.8-2.6q.1-.4.3-.7.2-.4.4-.7.4-.9,1-1.7.6-.9,1.3-1.6.5-.5,1-1q.5-.4,1-.9.2-.2.5-.4t.5-.4q.2-.1.4-.3.2-.1.4-.3.3-.2.7-.4t.8-.4q0-.1,0-.1t.1,0c1.8-1,3.6-2,5.4-3c1.9-1,3.8-1.9,5.7-2.6q3.9-1.3,7.8-2.6q4-1.2,7.9-2.4.7-.2,1.5-.5.7-.2,1.6-.5.3-.1.6-.2t.6-.2q.2,0,.4-.1.3-.1.5-.1.2-.1.4-.1.2-.1.5-.1.4-.1.8-.1.4-.1.8-.1q1-.1,1.9.1q1,.2,1.8.8.3.2.7.5.3.3.7.6Z",
    fill: "url(#es3kTfY9O2J90-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1683.1,787.9c.8,1.2,1.7,2.5,2.5,3.8.7,1.4,1.3,2.8,1.4,4.3q.1.6.1,1.2q0,.5-.1,1.1c-.3.8-.8,1.4-1.5,1.9-.6.5-1.3.9-1.8,1.4q-.6.5-1.2,1-.5.5-1.2.9c-2.2,1.3-4.9,1.4-7.3.7s-4.6-2.2-6-4.1c-.6-.9-1.6-2.7-2-4.4s-.2-3.3,1.5-4.1q.5-.3,1-.6.5-.2,1.1-.4q1-.4,2.1-.6q1.1-.3,2.2-.4q1.3-.1,2.6-.1q1.4,0,2.7-.1.5-.1.9-.2.4-.2.8-.6c.2-.2.5-.5.7-.8.3-.3.5-.5.8-.4.2,0,.3.1.4.2.2.1.3.2.3.3Z",
    transform: "translate(1.390149 0.935169)",
    fill: "url(#es3kTfY9O2J92-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1687.2,796.9c.2.7.1,1.2-.1,1.7-.3.5-.6,1-1,1.5q0,0,0,0q0,.1-.1.1q0,0-.1.1t-.2.3c-.4.4-.8.7-1.3,1-.4.3-.9.6-1.4.8q-.1.1-.2.1-.1.1-.2.1-.5.2-1,.4t-1,.4q-.5.1-.9.2t-.8.2q-.8.1-1.6-.1t-1.5-.6q0,0,0,0t0,0c-.8-.5-1.6-1.1-2.2-1.9-.7-.7-1.2-1.5-1.6-2.3q-.1-.2-.2-.3-.1-.2-.2-.4c-.1-.5-.3-1-.3-1.4.1-.5.2-1,.7-1.4q.7-.7,1.6-1.2q1-.5,1.9-.8c1.6-.6,3.2-1.1,4.7-1.2c1.6,0,3.1.4,4.5,1.5q.4.4.9.8.4.4.8.9.2.3.4.6.1.2.3.5q0,.1.1.2q0,.1,0,.2Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1708.5,776.5q0,0,.1,0q0,0,0,.1c.2,1.2.3,2.5.5,3.8.1,1.4.2,2.7.4,4q.2.8.4,1.7t.2,1.8c0,0-.1,0-.3,0-.1.1-.3.1-.3.1.1,0,.1.1.1.2s0,.2,0,.2c-.3,1.2-.6,2.2-1.1,3s-1.1,1.4-2.2,1.9c-.7.3-1.3.5-2,.5-.7.1-1.4-.1-2-.5q-.8-.5-1.4-1.3-.5-.8-.8-1.7c-.5-1.4-.8-2.9-.9-4.5s.1-3.1.6-4.5q0-.1.2-.3.1-.1.3-.2.8-.8,1.7-1.5t1.8-1.3c.7-.4,1.4-.9,2.3-1.2.8-.4,1.6-.5,2.4-.3Z",
    fill: "url(#es3kTfY9O2J95-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1709.5,785.1q0,.2.1.4t.1.5q.1.1.1.3.1.2.1.3.2.6.2,1.3.1.6.1,1.2q0,0,0,.1t0,.1c-.1.6-.3,1-.5,1.4-.3.4-.7.8-1.1,1.1q-.1.1-.1.1-.1.1-.2.2-.2.2-.4.4-.3.2-.5.4c-.7.5-1.4.9-2.2,1.1-.7.3-1.5.3-2.2.1q-.3-.1-.5-.2-.3-.2-.5-.4q0-.1,0-.1-.1,0-.1,0-.4-.5-.7-1.1t-.3-1.3q-.2-.9-.1-1.9.1-.9.3-1.8c.3-1.1,1.1-2.2,2-3s2-1.5,3.1-1.9c.4-.2.8-.3,1.1-.3.4,0,.7.2,1,.6q.2.3.4.6.1.3.3.6.1.3.2.6.2.3.3.6Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1700,807q.8,0,1.7-.1.8-.1,1.6-.4.7-.3,1.4-.6t1.3-.7q.3-.2.6-.5.3-.2.6-.4c.1-.1.1-.2.2-.2.1-.1.1,0,.2.1q.1.1.1.3.1.1.1.2q0-.2-.1-.3q0-.1-.1-.3c-.1-.2-.3-.4-.5-.5-.2-.2-.4-.2-.5-.1-.4.3-.7.6-1.1.9-.3.2-.6.4-.8.5q-.9.5-1.9.9-.9.3-2,.5-.4.1-.9.2t-1,.2c-.1,0-.3,0-.5,0-.3.1-.6,0-1.1-.1q.3.1.5.2.3.1.6.1.4,0,.8.1.4,0,.8,0Z",
    fill: "#ffe5d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.6,804.2c-.1-.1-.1-.2-.2-.1-.1,0-.1.1-.2.2q-.3.2-.6.4-.3.3-.6.5-.6.4-1.3.7t-1.4.6q-.8.3-1.6.4-.9.1-1.7.1-.4,0-.8,0-.4-.1-.8-.1-.3,0-.6-.1-.2-.1-.5-.2-.1,0-.2-.1-.1,0-.2,0-.1.1-.3.3-.1.2-.2.4-.3.4-.7.9t-.6,1q-.2.4-.1.8.1.3.3.6.2.2.3.4.2.2.3.3.2.2.3.4.2.1.5.1.1,0,.2,0q.1-.1.2-.1.1-.1.3-.2.1-.1.3-.1.1-.1.3-.2.1-.1.3-.1c.5-.3,1.1-.4,1.7-.5s1.1-.1,1.7-.2q.8,0,1.6-.2t1.6-.4q.8-.3,1.4-.7.7-.4,1.1-1.1c.2-.5.4-1,.5-1.5s.1-1.1-.1-1.6q0,0,0,0q0-.1,0-.1q0-.1-.1-.2q0-.2-.1-.3Z",
    fill: "url(#es3kTfY9O2J98-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1703.1,832.8c0,0,.1.3.2.6.1.2.1.5.1.4c0,0-.5.7-1,1.5-.6.8-1.2,1.7-1.5,2q-.8,1.1-1.7,2.1t-1.9,1.9q-1.9,2-3.9,3.7-2,1.8-4.1,3.4c-2.8,2.2-5.6,4.3-8.6,6.3s-6,3.9-9.2,5.5q-.1,0-.1-.1q0,0-.1,0-.5-.6-.7-1.2t-.1-1.2c.2-.5.5-1.4.8-2.7.3-1.2.6-2.8.8-4.7q0-.3.1-.6q0-.3,0-.6c.3-3.1.2-5.9-.1-8.5s-.8-5-1.4-7.4q-.1-.1-.1-.2q0,0,0-.1-.3-1.3-.7-2.5-.4-1.3-.8-2.5-.9-2.6-1.8-5.1-1-2.4-2-4.8-.3-.7-.6-1.4t-.6-1.4q-.8-1.8-1.6-3.6-.7-1.9-1.6-3.7q0-.1,0-.1t0-.1c.1-.6.2-1.2.3-1.8s.2-1.1.4-1.6q1.6,2.3,3,4.8q1.4,2.4,2.7,4.9q1.1,2.4,2.4,4.6q1.3,2.3,2.5,4.6c.6,1.2,1.3,2.4,2.1,3.5.8,1,1.8,2,3.1,2.6q.8.3,1.6.6.9.3,1.7.5q2.4.7,4.7,1.2q2.4.6,4.8.9q1.6.3,3.3.5q1.6.2,3.3.2.8,0,1.7,0q.8,0,1.7,0c.3-.1.8-.1,1.3-.2s1.1-.1,1.6-.2Z",
    fill: "url(#es3kTfY9O2J99-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1708.2,805.5q0,.6-.2,1.2t-.5,1.1q-.2.3-.4.6t-.6.5q.2-.2.3-.3t.1-.2q.2-.3.3-.5.2-.3.3-.6t.2-.6.1-.6q.1-.4.1-.8q0-.5-.2-.9-.1-.1-.2-.3-.1-.1-.2-.2-.3-.2-.5-.3-.3-.1-.6-.2-.2-.1-.4-.3-.2-.1-.5-.2c-.3-.2-.7-.5-1-.9-.4-.3-.8-.7-1-.9-.4-.4-.6-.7-.9-1.1-.2-.3-.5-.6-.8-1q-1.2-1.7-2-3.7-.8-1.9-1.2-4-.2-1.4-.2-2.9.1-1.4.4-2.8q0-.3.1-.6q0-.2.1-.5t.2-.5q.1-.1.2-.4q0,0,0,0q.1,0,.1,0t0,.1q0,0,0,0-.3,1.1-.5,2.3-.2,1.1-.2,2.3q0,.6.1,1.2q0,.6.1,1.2c.1,1.3.4,2.5.9,3.7.4,1.2.9,2.3,1.6,3.4.3.4.6.9.9,1.4.4.5.8.9,1.1,1.3.4.5.8,1,1.3,1.4.4.4.9.7,1.5,1.1q.2.1.5.2.2.1.5.2.2.1.3.2.2.1.3.3.3.3.4.7.1.5.1.9Z",
    fill: "url(#es3kTfY9O2J100-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1697.1,751.1q-1.5-.2-2.9-.2-1.4.1-2.9.3c-1.1.1-2.1.4-3.1.7s-1.9.7-3,1.1c1-2,2.2-4,3.7-5.7c1.5-1.8,3.2-3.4,5-4.6-.7-.9-2.1-1.5-3.5-2-1.5-.4-3-.6-4.1-.7q-4.9-.5-9.5.5c-3.2.6-6.2,1.7-9.1,3.2q-2.4,1.3-4.6,2.9-2.2,1.5-4.1,3.4c-.8.8-1.5,1.6-2.2,2.4s-1.4,1.6-2.1,2.4c-.6.8-1.2,1.6-1.7,2.4s-1,1.6-1.7,2.3c-.9-.6-2.1-.9-3.4-1-1.2-.1-2.5,0-3.6.3q-1.3.3-2.5.9-1.2.7-2.3,1.5c-.5.3-1.3.9-1.9,1.5-.7.7-1.2,1.5-1.2,2.1c1.8-1,3.9-1.4,5.8-1.2c2,.3,3.8,1.2,5.2,2.8-1.4.4-2.8,1-4.1,1.8-1.3.9-2.4,1.9-3.4,2.9q-.7.7-1.2,1.4-.6.7-1,1.5c-.3.5-.6,1-.9,1.6-.2.5-.4,1.1-.4,1.6c1-.7,2.2-.8,3.4-.5c1.1.2,2.2.8,3.1,1.5.8.7,1.5,1.5,2.1,2.3s1.2,1.7,1.7,2.6q.9,1.3,1.9,2.7.9,1.3,1.8,2.7q1.5,2.5,2.9,5q1.5,2.5,2.8,5q1.1,1.8,2.1,3.7q1,1.8,1.8,3.7c.3.7.6,1.3.9,1.9.2.6.5,1.2.8,1.8.4.9.7,1.5,1,2.2.2.7.5,1.3.9,2.2-.1-.1.1-.3.2-.6.2-.2.4-.4.5-.5q.2-.2.4-.4t.4-.4c.1,0,.3-.2.5-.4.2-.1.3-.3.3-.4q-.4-.7-.8-1.4-.4-.8-.8-1.5t-.7-1.5q-.4-.7-.7-1.4-.1-.3-.3-.6-.1-.3-.3-.6-.1-.3-.2-.6t-.3-.5q-1.8-4-3.3-8-1.4-4.1-2.7-8.2-.2-.6-.3-1.2-.2-.6-.3-1.3q0-.1,0-.2t0-.2q0,0,.1-.1q0,0,.1-.1.3-.3.7-.7.3-.3.7-.6c.1-.1.4-.3.6-.5.3-.2.5-.4.6-.5q0-.1,0-.1q0-.1,0-.1-.3-.9-.6-1.7t-.6-1.6q-.2-.4-.4-.9-.1-.5-.3-1-.1-.2-.3-.5-.1-.3-.2-.6q0-.1,0-.1-.1-.1-.1-.2-.1-.2-.2-.4-.1-.3-.1-.5c1.4.1,2.9-.1,4.5-.4c1.5-.3,3-.6,4.4-1c3.1-.9,6.3-1.6,9.4-2.4c3.2-.8,6.3-1.7,9.3-3.1q2.2-1.1,4.3-2.2q2.1-1.2,4.2-2.5c1.3-.8,2.4-1.7,3.5-2.6c1.1-1,2.1-2,3.2-2.9c1.2-.6,2.9-.7,4.6-.6c1.7.2,3.4.5,4.5.8-1.3-1.5-2.8-2.8-4.5-3.9-1.7-1-3.5-1.7-5.5-2Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1697.9,780.3c.5.2,1-.1,1.5-.5.5-.3.8-.8,1.1-1.1q.6-.8,1.3-1.5.6-.7,1.3-1.3.9-.8,1.9-1.5q1.1-.6,2.2-1.1.2-.1.5-.2.3,0,.6.1c.2.1.4.3.5.6.2.2.3.5.4.6q.1.4.2.8.1.5.1.9q0,.3-.1.6-.1.4-.2.7-.1.1-.1.2-.1,0-.1.1-.2.2-.4.4-.2.1-.4.3-.3.2-.6.4-.2.2-.5.4t-.7.5q-.3.2-.6.4-1.1.9-2.2,1.8-1.1.8-2.2,1.6c-.3.2-.7.5-1.1.7-.4.1-.8.2-1.2-.1q-.2-.1-.4-.3-.1-.1-.2-.3c-.3-.5-.5-1-.6-1.6c0-.5,0-1.1,0-1.6Z",
    fill: "url(#es3kTfY9O2J102-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.1,785c.1.1-.2.3-.6.5s-.8.4-.9.4c-.4.1-.9.3-1.5.4s-1.2.2-1.6.3q-1.1.1-2,.1-.9.1-1.7.3c-1.4.2-2.5.4-3.6.7-1,.2-2.1.4-3.5.8q-.5.2-1,.3-.5.2-.9.5-.3.3-.6.6t-.5.6q-.3.4-.6.8-.2.5-.4.9-.4,1-.4,2.1-.1,1.1.3,2.1c.1.2.3,0,.5-.2.2-.3.4-.6.4-.7.5-.5,1.2-1,1.9-1.3.7-.4,1.5-.7,2.2-.9q1.3-.5,2.6-.9q1.3-.3,2.6-.6c.9-.2,1.6-.3,2.4-.4.7-.1,1.4-.3,2.3-.4.6-.1,1.2-.2,1.8-.3s1.1-.2,1.5-.4q.5-.2.9-.5t.7-.9q.2-.3.3-.6.1-.4.1-.8c-.1-.4-.1-.9-.2-1.3-.1-.5-.2-.9-.5-1.2Z",
    fill: "url(#es3kTfY9O2J103-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.9,812.2c-.3.3-.7.4-1.2.5-.4.1-.9.1-1.2.1q-.7,0-1.3-.1t-1.2-.4c-.6-.2-1.3-.7-1.9-1.3-.5-.5-1-1.2-1.3-1.9q-.2-.5-.2-1-.1-.5,0-1c.1-.5.4-.9.7-1.3s.6-.8,1-1q1-.8,2.2-.8q1.1,0,2.2.6.4.2.8.5.4.2.7.5.1,0,.1,0q.1.1.1.2.2.1.3.2t.2.2c-.4-.3-.9-.5-1.4-.5-.5-.1-1-.1-1.5.1q-.3.2-.6.5-.2.2-.4.6c-.3.8-.2,1.6.1,2.4.3.7.9,1.4,1.5,1.8q.5.5,1.1.7.5.3,1.2.4Z",
    fill: "#910f2e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1695.8,807.9q-.2.2-.3.4-.2.1-.3.3-.1.1-.2.3-.1.1-.2.3-.2.4,0,.8.1.3.4.7.2.3.5.6.3.2.7.4c0,0-.2-.2-.4-.4s-.4-.5-.6-.7c-.1-.1-.2-.3-.2-.5-.1-.2-.2-.3-.2-.5q0-.2.1-.3.1-.2.2-.3.3-.3.5-.7.2-.3.5-.6.1-.2.2-.3.1-.2.2-.4c.1,0,.2-.2.2-.4.1-.1.1-.2,0-.1q-.2.3-.5.7t-.6.7Z",
    fill: "#cc5e48"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1702.6,810.4c0-.1-.1-.2-.3-.3-.2,0-.3-.1-.4-.1q-.3-.1-.6-.1t-.5,0c-.4,0-.8,0-1.2,0q-.6.1-1.1.4-.2.1-.3.3q0,.2.2.4.2.1.4.2.2,0,.5,0q.4-.1.8-.2t.8-.2q.4-.2.8-.3.5-.1.9-.1Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1687.4,797.3v.1.1c.2.6.1,1.1-.1,1.7-.3.5-.6.9-1,1.4q0,.1,0,.1-.1,0-.1.1q0,0-.1.1t-.2.2c-.5.4-.9.8-1.3,1.1s-.9.5-1.4.8q-.1,0-.2.1-.1,0-.2.1-.4.1-.8.2-.3.2-.7.3-.1.1-.2.1t-.2.1h-.1-.1q-.4.2-.8.3-.4,0-.8.1t-.7,0q-.3,0-.7,0-.7-.1-1.3-.4t-1.2-.8q-.2-.2-.5-.4-.2-.3-.5-.6-.3-.2-.5-.5-.3-.2-.5-.5-.3-.4-.6-.8-.2-.4-.5-.8q0-.2-.1-.4t-.2-.3c-.2-.5-.3-1-.3-1.5s.2-.9.6-1.3q.8-.8,1.7-1.2.9-.5,1.9-.9c1.6-.6,3.2-1.1,4.7-1.1c1.6-.1,3.1.3,4.4,1.4q.5.4,1,.8.4.5.8,1q.2.2.3.5.2.3.4.6q0,0,0,.1q0,0,.1.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1687.4,797.3q-1.5,0-2.9.1t-2.8.5q-.8.1-1.5.3-.8.2-1.5.5-.4.1-.6.1-.3.1-.6.3-1.1.4-2.2.9-1,.5-2.1,1.1-.3-.4-.6-.8-.2-.4-.5-.8q0-.2-.1-.4t-.2-.3c-.2-.5-.3-1-.3-1.5s.2-.9.6-1.3q.8-.8,1.7-1.2.9-.5,1.9-.9c1.6-.6,3.2-1.1,4.7-1.1c1.6-.1,3.1.3,4.4,1.4q.5.4,1,.8.4.5.8,1q.2.2.3.5.2.3.4.6q0,0,0,.1q0,0,.1.1Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1681,803.8q-.6-.4-1.2-1-.5-.6-.8-1.4c-.4-1.2-.3-2.4.3-3.5.5-1,1.5-1.9,2.7-2.3c1-.3,2-.3,2.9-.1c1,.3,1.8.9,2.4,1.7q.1.1.1.2t.1.1c.1.6.1,1-.1,1.5-.2.4-.5.8-.8,1.3l-.1.1-.1.2q-.1.1-.2.2t-.2.3c-.5.4-.8.7-1.2,1-.3.2-.7.5-1.2.7l-.4.2-.4.2q-.5.1-.9.3-.4.1-.9.3Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1687.4,797.3q-1.5,0-2.9.1t-2.8.5q-.7.1-1.5.3-.7.2-1.4.5.3-1.1,1-2q.8-.8,2-1.3c1-.3,2.1-.3,3,0c1,.3,1.9.9,2.5,1.7q0,0,0,.1q0,0,.1.1Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1679,801.2q.3.8.8,1.3.4.6,1.1,1q.1,0,.2.1t.2.1q-.1.1-.2.1t-.2.1q0-.1,0-.1t-.1,0q-.7-.4-1.2-1-.5-.7-.8-1.5c-.4-1.2-.3-2.4.2-3.5.6-1.1,1.5-2,2.7-2.5q0,.1.1.2q0,.1,0,.1c-1.1.5-2,1.3-2.5,2.3s-.6,2.2-.3,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1686.3,798.9q.1.4.1.9q0,.4-.1.8q0,.1,0,.1-.1,0-.1.1q0,0-.1.1t-.2.2c-.5.4-.9.8-1.3,1.1s-.9.5-1.4.8c-.6,0-1.3-.2-1.8-.6-.5-.3-.9-.8-1.1-1.5-.3-.8-.2-1.6.2-2.3.3-.7,1-1.3,1.8-1.5.8-.3,1.7-.3,2.4.1.7.3,1.3.9,1.6,1.7Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1686.6,795.9q.4.6.6.9.1.4.1.4c-.1-.2-.8-.5-1.5-.9-.8-.4-1.5-.7-1.8-.7s-.7-.2-1-.3-.7-.2-1-.1q-.9.1-1.7.3-.9.1-1.8.4t-1.8.7q-.8.4-1.7.8-.8.4-1.6.7-.8.4-1.6.7c-.2-.5-.3-1-.3-1.5s.2-.9.6-1.3q.8-.8,1.7-1.2.9-.5,1.9-.9c1.6-.6,3.2-1.1,4.7-1.1c1.6-.1,3.1.3,4.4,1.4q.5.4,1,.8.4.4.8.9Z",
    fill: "url(#es3kTfY9O2J114-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1687.3,797.2c0-.1-.2-.2-.4-.3s-.4-.2-.5-.2q-.6-.2-.9-.3-.4-.1-.6-.2c-.3,0-.5-.1-.7-.1-.2-.1-.4-.1-.7-.1q-.9,0-1.8.1-.9.2-1.7.4-.7.2-1.3.4t-1.2.4q-.7.3-1.3.6-.7.3-1.4.6-.6.3-1.3.5-.6.2-1.3.4c-.6.1-1-.1-1.3-.3-.4-.3-.6-.7-.9-1.1.1.1.4.1.6.1.2-.1.5-.2.6-.2q.5-.1.9-.3t.9-.3q1.1-.4,2.2-.8q1.1-.3,2.2-.7c1.1-.3,2.3-.6,3.5-.7s2.5,0,3.6.4q.4.1.7.3.4.1.8.3c.1.1.4.4.7.6s.6.4.6.5Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680.8,797.9q.2.2.2.5q0,.2-.2.4t-.4.2q-.3,0-.5-.2t-.2-.4q0-.3.2-.5.2-.1.5-.1.2,0,.4.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1709.7,785.7q0,.1,0,.2q0,0,.1.1q0,.4.1.7t.2.7v.1.1.1c0,0,0,.1.1.3c0,.2,0,.4.1.5q0,.2,0,.3q0,.2,0,.4.1.3.1.6-.1.4-.2.7-.1.6-.5,1.1-.4.4-.9.8-.1.1-.1.2-.1,0-.2.1q0,.1-.1.1-.1.1-.1.1-.2.2-.4.3-.2.2-.3.3-.1,0-.1,0q0,.1-.1.1-.1.1-.2.2-.2.1-.3.1-.2.1-.4.3-.2.1-.4.1-.1.1-.1.1-.1,0-.2.1-.7.2-1.3.3-.7.1-1.3-.1-.3-.1-.5-.2t-.3-.2-.1-.2q-.1-.1-.3-.2-.4-.5-.6-1.1-.3-.6-.3-1.2-.2-.7-.1-1.5q0-.8.2-1.5q0-.2,0-.3.1-.2.1-.4c.3-1.1,1.1-2.1,2-3c.9-.8,2-1.5,3.1-1.9.4-.2.8-.3,1.1-.3.4,0,.7.2,1,.6q.1.1.1.1.1.1.1.2.2.2.3.4t.2.5.2.6q.2.3.3.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1709.7,785.7q0,.1,0,.2q0,0,.1.1q0,.4.1.7t.2.7v.1.2q-.3.2-.7.4-.3.2-.6.3-.9.5-1.8,1t-1.7,1.1q-.4.3-.7.6-.4.3-.7.6-.6.5-1,1-.5.5-.9,1.2-.4-.5-.6-1.1-.3-.6-.3-1.2-.2-.7-.1-1.5q0-.8.2-1.5.9-1.1,2-2q1.2-1,2.5-1.6.7-.4,1.4-.8.8-.3,1.6-.6.2.2.3.4t.2.5.2.6q.2.3.3.6Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705.9,794.4q-.5-.3-1-.9t-.8-1.2q0-.2-.1-.3q0-.2,0-.3q0-.2,0-.4t0-.4q-.1-.1,0-.2q0-.1,0-.2q0-.3.1-.6.1-.2.2-.4q0-.2.1-.2q0-.1.1-.2.1-.2.1-.3.1-.1.2-.2.1-.2.2-.3.2-.2.3-.3.2-.1.4-.2.1-.2.3-.2.2-.1.4-.2.1-.1.3-.2.9-.3,1.7-.2.9.1,1.6.5h.1c0,.2.1.6.1.9.1.3.1.6.2.8q0,.2,0,.5q0,.2-.1.4q0,.1-.1.2q0,.1-.1.3t-.2.5q-.2.2-.4.5-.1.1-.3.2-.1.1-.2.2l-.4.4-.4.4q-.2.2-.3.4-.2.1-.3.3-.3.1-.4.3-.2.1-.3.1-.3.2-.5.3t-.5.2Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.1,787.4v.1.2q-.3.2-.7.4-.3.2-.6.3-.9.5-1.8,1t-1.7,1.1q-.4.3-.7.6-.4.3-.7.6-.1-.2-.1-.4t0-.4q0-.1,0-.2t0-.2q.1-.3.2-.6q0-.3.2-.5q0-.1.1-.2q0-.1.1-.2q0-.2.1-.3t.2-.2q.1-.2.3-.3.1-.2.3-.3.1-.1.3-.2.1-.2.3-.2.2-.2.4-.3.2,0,.4-.1.9-.3,1.8-.2.8.1,1.6.5Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.1,787.4v.1.1q0,0-.1,0-.1-.1-.3-.1c-.4-.2-.8-.3-1.4-.4-.5,0-1,.1-1.5.2q-.2.1-.4.2t-.3.2q-.3.2-.6.4-.2.2-.5.4-.2.3-.4.5-.1.3-.2.6-.1.1-.1.2-.1.1-.1.2-.1.5-.1,1-.1.4.1.9q0,.4.2.7t.4.6.4.5q.3.3.5.5.1,0,.2.1.1,0,.2.1q0,0-.1,0t-.2.1q-.1-.1-.2-.2-.1,0-.2-.1-.4-.3-.7-.7-.3-.3-.5-.8-.1-.3-.2-.5-.1-.3-.2-.7q0,0,0-.1t0-.2t0-.1q0-.1,0-.2q0-.4.1-.9.2-.4.4-.9.1-.3.3-.6.3-.2.5-.5.2-.1.4-.3.2-.1.4-.2.2-.2.4-.3.2,0,.4-.1.9-.3,1.8-.2.8.1,1.6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.4,789.7q0,.5-.1.8t-.2.4q-.2.3-.3.6-.2.2-.5.4-.1.1-.2.3-.2.1-.3.2t-.1.2q-.1,0-.2.1q0,.1-.1.1-.1.1-.1.1-.2.2-.4.3-.2.2-.3.3-.1,0-.1,0q0,.1-.1.1-.7-.1-1.2-.6-.6-.4-.8-1.1-.1-.4-.1-.7-.1-.3,0-.7.2-.7.6-1.2.5-.6,1.2-.8.5-.2.9-.2t.8.1q.1.1.2.1.2.1.3.1.2.1.3.2t.2.2.3.2q.1.1.1.2.1.1.1.2.1,0,.1.1Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1709.3,784.7q-.5.4-.9.8-.5.3-1,.7-.6.3-1.1.6t-1.1.6q-.7.5-1.4,1t-1.2,1.1q-.3.3-.5.7-.2.3-.3.7-.1.2-.2.4t-.1.4c-.1.1-.1.2-.2.3c0,.2-.1.3-.1.4q0,0,0-.2-.1-.2-.2-.7-.2-.9-.1-1.8.1-1,.3-1.8c.4-1.2,1.1-2.2,2-3c.9-.9,2-1.6,3.1-2c.4-.2.8-.3,1.2-.2.4,0,.8.2,1,.6q.2.3.4.7.3.3.4.7Z",
    fill: "url(#es3kTfY9O2J123-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1701.2,792.3q.2-.2.3-.4t.3-.4.3-.4q.2-.3.3-.5.3-.3.6-.6t.7-.6c.7-.6,1.4-1,2.1-1.4.8-.4,1.5-.7,2.3-1.1q.4-.2.9-.4.5-.3.8-.6t.4-.5q.1-.3.1-.6q0-.1,0-.3.1-.1,0-.3q0-.1,0-.2t0-.3q-.1.2-.4.4-.2.3-.5.5-.4.3-.8.6-.3.2-.7.5t-.8.5-.8.4c-.8.5-1.7.9-2.5,1.5s-1.5,1.3-2,2.2c-.1.2-.2.5-.3.7s-.1.5-.2.8q-.1.2-.1.3q0,.2,0,.2Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705.9,789.8q.2.2.2.4q0,.3-.2.5-.1.2-.4.2t-.5-.2q-.1-.2-.1-.5q0-.2.1-.4.2-.2.5-.2.2,0,.4.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1640,752.5c1.3-.1,2.4-.1,3.4.1.9.1,1.8.4,2.9.9c1,.5,1.9,1.1,2.7,1.9s1.5,1.7,1.9,2.7c-.3-.4-.7-.8-1.2-1.1-.5-.4-1-.7-1.4-1q-.7-.5-1.4-.9t-1.4-.8q-1.3-.8-2.7-1.2-1.3-.4-2.8-.6Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1648.9,804.1c-.4-1.4.2-2.5,1.3-3.1c1-.6,2.5-.8,3.6-.5q.5.1,1,.3.4.2.9.5c.2.1.4.4.6.7.1.3.1.6-.2.8-.2.2-.6.3-.9.4-.4,0-.7.1-1,.2q-.5.2-1,.5t-.9.6q-.5.3-.9.4-.4.2-1,.1c-.3,0-.6-.1-.9-.3-.3-.1-.5-.4-.6-.6Z",
    fill: "url(#es3kTfY9O2J127-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.9,806.2c-.4-.3-.9-.5-1.4-.5-.5-.1-1-.1-1.5.1-.4,0-.8.3-1,.7-.3.3-.5.8-.6,1.2s-.2.9-.1,1.4c0,.4.2.9.4,1.3.1.3.4.8.7,1.1.4.4.7.7,1.1.8-.6,0-1.3-.2-2-.4-.7-.3-1.3-.7-1.8-1.1q-.6-.5-.9-1.2-.4-.8-.5-1.6c-.1-.6.1-1.2.4-1.7s.8-.9,1.3-1.2c.9-.4,1.8-.6,2.7-.4.8.1,1.7.4,2.5.9q.1,0,.1,0q.1.1.1.2.2.1.3.2t.2.2Z",
    fill: "#b22842"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1659.2,752.7q-.1.2.1.4.1.1.3.3.5.2,1,.5.5.2,1,.3q1,.2,2,.2q1,.1,2,0q.4,0,.9-.1.5,0,.9-.2.3-.2.6-.5t.5-.6q1.3-1.2,2.7-2.4q1.3-1.1,2.7-2.2q1.5-1,3.1-1.8q1.6-.7,3.3-1c-1.7.6-3.3,1.5-4.7,2.6-1.5,1.1-2.8,2.5-3.8,4q-.1.2-.2.4t-.1.4c0,.7.8.7,1.6.5s1.7-.6,1.9-.7q1-.6,1.8-1.3t1.7-1.3c1.6-1.3,3.2-2.6,4.9-3.7c1.6-1.1,3.4-2.1,5.3-2.9-.1.1-.3.1-.6.1-.2-.1-.4-.1-.5-.1q-.4,0-.7.1-.4,0-.7,0-.7,0-1.4.1-.6.1-1.3.2-2.2.4-4.4.9t-4.4,1.2q1.3-.8,2.7-1.4q1.3-.6,2.7-1q.7-.3,1.5-.5.7-.2,1.4-.4.2,0,.4-.1.2,0,.4-.1.1,0,.3,0q.2-.1.3-.2c.2-.1.1-.1,0-.2s-.3-.1-.4-.1q-.3-.1-.7-.1t-.7-.1q-.7,0-1.5,0-.7.1-1.4.2-.8.1-1.7.2-.8.2-1.6.4c-1.7.3-3.3.7-4.9,1.2-1.6.6-3.1,1.2-4.6,2.1q-2,1.2-3.9,2.7t-3.4,3.3q-.2.2-.3.4t-.1.3Z",
    fill: "url(#es3kTfY9O2J130-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1686.2,800.8c0,0,0,0-.1.2c0,.1-.1.2-.2.3-.5.5-.9.8-1.3,1.1-.5.3-1,.6-1.6.9-.6.2-1.3.5-1.9.7-.7.2-1.4.4-2,.5q-.8.1-1.6-.1-.7-.3-1.4-.7c.6,0,1.2,0,1.7,0c.5-.1.9-.1,1.1-.2q1.3-.2,2.5-.6t2.3-.9q.6-.2,1.2-.5.5-.3,1-.6.1,0,.2,0q0-.1.1-.1Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1704.8,794.8q.8-.3,1.6-.7t1.5-1c.5-.3,1-.8,1.4-1.3.5-.5.8-1,1-1.6q0,.5-.2,1-.1.5-.3.9t-.6.8q-.4.3-.8.6-.5.2-1,.5t-1,.4q-.4.2-.8.2-.4.1-.8.2Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1702,818.4c.1.1,0,.3,0,.4c0,.2-.1.3-.1.3-.2.4-.4.7-.7,1-.3.4-.6.7-.9.9q-.5.4-1,.6-.5.3-1,.5-.5.3-1,.4-.6.1-1.1.2-1.2.1-2.2,0-1.1-.1-2.1-.6-.8-.4-1.4-1t-.9-1.4q-.2-.5-.4-1t-.4-1q-.1-.4-.3-.9-.1-.5-.1-1c.1-.1.1-.2.1-.3s.1-.2.1-.1c.1,0,.2.1.3.3.1.1.2.3.3.3.7.8,1.6,1.5,2.5,2c1,.5,2,.8,3.1,1c1.2.3,2.4.3,3.6.2c1.2-.2,2.4-.4,3.6-.8Z",
    fill: "#b22842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1698.5,819.7q.1.4.1.8t0,.8q-.1.2-.1.4-.1.2-.2.4-.5.3-1,.4-.6.1-1.1.2-1.2.1-2.2,0-1.1-.1-2.1-.6c-.8-.4-1.5-1.1-2-1.9-.6-.7-.9-1.6-1.2-2.5q0-.3-.1-.6t-.1-.6c0-.2-.1-.4-.1-.6s0-.3.1-.5q.1-.1.1-.1t.1,0q0,.1.1.1.1.1.1.2.5.4.9.8.5.4,1,.8.6.4,1.2.7.6.2,1.2.4q1.2.4,2.5.6q1.3.1,2.6,0q.1.2.1.4.1.2.1.4Z",
    fill: "url(#es3kTfY9O2J135-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1687,815q0-.1,0-.2q0,0,0-.1t0-.1q0-.1,0-.2t0-.2q0-.2,0-.3.1-.2.1-.3.1-.1.2-.2.1-.3.4-.4t.5-.1q.2-.1.4-.1.1,0,.3.1q0,0,.1,0t.2,0q0,0,.1.1.1,0,.1,0c0,0-.2.1-.4.1-.3.1-.6.2-.7.3q-.4.2-.6.4t-.4.5q-.1.2-.2.3-.1.2-.1.4Z",
    fill: "url(#es3kTfY9O2J136-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1702.2,817.8c0,0,0,.2,0,.5c0,.2-.1.6-.3.8q-.8.3-1.6.4-.9.2-1.8.2-.3.1-.5.1-.3,0-.6,0-1.1.1-2.3-.1-1.1-.3-2.1-.6-.3-.1-.6-.3-.3-.1-.6-.2-.7-.3-1.3-.8t-1.2-1.1q-.2-.3-.4-.6t-.4-.6q.1-.1.1-.2.1-.1.2-.1c.6.8,1.4,1.4,2.2,1.9.9.6,1.9.9,2.9,1.2q1,.2,2.1.2q1.1.1,2.2,0q.3,0,.6,0q.3-.1.6-.1t.7-.1q.3-.1.7-.1.3-.1.7-.2.3-.1.7-.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1702.2,817.8q-.1.1-.1.2t0,.2q-.3.1-.5.1-.2.1-.3.1-.7.2-1.3.4-.7.1-1.3.3-1.5.2-2.9.2t-2.8-.2q-.3-.1-.6-.3-.3-.1-.6-.2-.7-.3-1.3-.8t-1.2-1.1q-.2-.3-.4-.6t-.4-.6q.1-.1.1-.2.1-.1.2-.1c.6.8,1.4,1.4,2.2,1.9.9.6,1.9.9,2.9,1.2q1,.2,2.1.2q1.1.1,2.2,0q.3,0,.6,0q.3-.1.6-.1.7-.1,1.4-.2.7-.2,1.4-.4Z",
    fill: "url(#es3kTfY9O2J138-fill)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M1664.3,850.6c0,0-22.4,10.5-25.6,56.1-3.3,45.5-4.7,72.3-4.7,72.3h105.3c0,0,0-22.1-.4-38-.5-15.9,2.8-27.4,2.4-49.1-.3-21.7-11.2-42.7-11.2-42.7s-35-9-65.8,1.4Z",
    fill: "url(#es3kTfY9O2J139-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.8,850.1l5.4-13.9c6.2,3.9,18,7.3,30.4,7.4l-5.6,15.5c0,0-19.7-.5-30.2-9Z",
    fill: "#f2e9e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1939.7,836.8c0,0,20.2-1.2,25.8-25.6c5-22-10.5-38.5-27-36.7c0,0-10.5-7.1-24.2,5.9s1.5,34.8,1.5,34.8l23.9,21.6Z",
    fill: "#bc6861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1944.9,853.7c-4.8-16-1.8-32-1.8-32l-14-1.4-13.5,1.5c1.4,8.5,3.7,24.7.9,31.8-.6,1.3,6.5,5.6,13.3,5.5c7.6,0,15.4-4.5,15.1-5.4Z",
    fill: "url(#es3kTfY9O2J142-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1942.8,843.6c-1.5-12,.3-21.9.3-21.9l-11.4-1.1-15.5,4.8c1.3,8.9,2.7,22,.3,28.2c0,0-1.7.7-4.1,1.5c1.1,1.2,3.6,3.7,5.8,4c3.2.6,17.9-6.4,24.6-15.5Z",
    fill: "url(#es3kTfY9O2J143-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1911.4,844.7c2.5,1.1,17.6,2.4,28.1-11.4c5.6-7.3,8.7-17.1,9-23.5.2-6.4-1.6-27.1-22.1-25.7c0,0-16.6,1.2-22.4,25.8-5.2,22.1,4.6,33.6,7.4,34.8Z",
    fill: "url(#es3kTfY9O2J144-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1916.4,804.1c-1,.8-2.1-1-6-1.9-2.7-.6-4.7,1-4.8.3-.1-.8,1.6-3.3,5.9-2.7c4.4.7,6.1,3.2,4.9,4.3Z",
    fill: "#bc6861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1924.9,806.4c-.1,1.5,3.3.8,7,2.8c3.8,2.1,4.5,4.8,5.4,4.2.5-.2,0-4.5-4.9-7.1-4.5-2.3-7.4-1.4-7.5.1Z",
    fill: "#bc6861"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1914.2,825.2c0,0-.4-.1-1-.4-.6-.4-1.5-.9-2.4-1.8-.5-.5-.9-1.1-1.2-1.8-.1-.4-.3-.8-.3-1.2c0-.3,0-.5,0-.8q0-.1.1-.3q0-.1.1-.3l.1-.1v-.1l.1-.1c0,0,.4-.3.5-.4q.2-.1.4-.1l.5-.2l1-.4q1.1-.3,2-.8c1.2-.7,2.3-1.7,3-2.8.6-1.1,1-2.3,1.1-3.4s.1-2,0-2.7c0-.6-.1-1-.1-1c0-.2.1-.4.3-.4s.4.1.4.3c0,0,.1.4.2,1c.1.7.2,1.7.2,2.9-.1,1.1-.3,2.6-1,3.9-.7,1.4-1.9,2.7-3.3,3.6q-1,.6-2.1,1.1l-1,.4-.5.2-.2.1c0,0,.2-.2.1,0c.2-.3.1-.1.1-.2q0,0,0,.1q0,0,0,.1t0,.3c-.1.2,0,.5.1.7.1.5.3,1,.6,1.4.6.8,1.4,1.3,1.8,1.7.6.3.9.5.9.5.3.2.4.5.2.8-.1.3-.4.4-.7.2Z",
    fill: "url(#es3kTfY9O2J149-fill)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1908.6,808.2c-.7,1.2-.6,2.6,0,3.1.7.5,1.8,0,2.4-1.2.7-1.1.7-2.5,0-3-.7-.6-1.7,0-2.4,1.1Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1913.4,811.6c0,0-.3-2.1-2.8-3.6-1.7-1-2.3.8-4,.4-.6-.1-1.4-1.1-1.2-2.1c0,0,.3.9,1.3.6.7-.2,2.8-1.9,4.9-.7c2.5,1.4,2.7,3.8,1.8,5.4Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1925.8,815c.3-1.4,1.4-2.6,2.4-2.6s1.4,1.1,1.1,2.5c-.4,1.4-1.5,2.5-2.4,2.5-1,.1-1.5-1-1.1-2.4Z",
    fill: "#625153"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1924.5,814c0,0,1.7-1.1,4.7.2c2,1,1.6,2.2,3.1,3.5.5.4,1.9.6,2.7-.3c0,0-1,.3-1.4-.8-.2-.8-1-3.1-3.4-4.5-2.4-1.3-4.7,0-5.7,1.9Z",
    fill: "#625153"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1924.7,830.2c0,0-4.1.2-8.4-.4-4.1-.5-7.2-2.1-7.2-2.1s-.2,8,7.2,8.8c5.6.7,8.4-6.3,8.4-6.3Z",
    fill: "#625153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1916.5,832.7c-4.3-.5-4.7-2.5-4.7-2.5s2.3.7,5.4,1c3.9.3,5.2.2,5.2.2s-1.7,1.8-5.9,1.3Z",
    fill: "#efebf2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1893,801.6c2.7,4.6,8.7,1.3,19-4.7c10.3-5.9,23.9.3,30.9-6.7c0,0-8.9-16.6-25.7-10.3-11.2,4.1-13.6,14.6-16.9,18.1-3.2,3.6-7.3,3.6-7.3,3.6Z",
    fill: "#bc6861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1939.3,790.6c0,0-.9,4.2,2,10c2.3,4.7,2.9,10.1,2,14.1-.9,3.9-1.1,7.4,1.1,7.4c2.1,0,8.8-4.9,9-16.8.2-10.2-8-18.1-8-18.1l-6.1,3.4Z",
    fill: "#bc6861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1944.8,820.3c0,0,4.8-6.5,8.2-1.9c1.8,2.3.3,7-2.7,9.7-2.2,2.1-6.4,3.2-8.4.7c0,0-2-1.5,2.9-8.5Z",
    fill: "url(#es3kTfY9O2J164-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1948.6,826.1c-1.6,1.7-3.7,2.1-4.4,1.1-.6-1,.2-3.2,1.8-4.9c1.6-1.8,3.4-2.4,4.1-1.4.6,1,.1,3.4-1.5,5.2Z",
    fill: "url(#es3kTfY9O2J165-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1967.7,869.1c16.6,13,29.6,54.9,33.2,104.1h-27.1c0,0-6.7-36.1-24.4-68.6l18.3-35.5Z",
    fill: "#625153"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1720,709.6c-.9,0-1.6-.7-1.6-1.6v-14.1c0-.9.7-1.6,1.6-1.6s1.6.7,1.6,1.6v14.1c0,.9-.7,1.6-1.6,1.6Z",
    fill: "#a8c7bf"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1727.1,702.6h-14.1c-.9,0-1.7-.7-1.7-1.6s.8-1.7,1.7-1.7h14.1c.9,0,1.6.8,1.6,1.7s-.7,1.6-1.6,1.6Z",
    fill: "#a8c7bf"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1947.4,741.1c-.9,0-1.6-.7-1.6-1.6v-14.1c0-.9.7-1.7,1.6-1.7s1.7.8,1.7,1.7v14.1c0,.9-.8,1.6-1.7,1.6Z",
    fill: "#ffcf83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1954.5,734h-14.1c-.9,0-1.6-.7-1.6-1.6s.7-1.6,1.6-1.6h14.1c.9,0,1.6.7,1.6,1.6s-.7,1.6-1.6,1.6Z",
    fill: "#ffcf83"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1840.4,655.8c-.9,0-1.6-.8-1.6-1.7v-14.1c0-.9.7-1.6,1.6-1.6s1.6.7,1.6,1.6v14.1c0,.9-.7,1.7-1.6,1.7Z",
    fill: "#ffcf83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1847.5,648.7h-14.1c-.9,0-1.7-.7-1.7-1.6s.8-1.6,1.7-1.6h14.1c.9,0,1.6.7,1.6,1.6s-.7,1.6-1.6,1.6Z",
    fill: "#ffcf83"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2031.1,670.8c-.9,0-1.6-.8-1.6-1.7v-14.1c0-.9.7-1.6,1.6-1.6s1.7.7,1.7,1.6v14.1c0,.9-.8,1.7-1.7,1.7Z",
    fill: "#d25a5a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2038.2,663.7h-14.1c-.9,0-1.6-.7-1.6-1.6s.7-1.6,1.6-1.6h14.1c.9,0,1.6.7,1.6,1.6s-.7,1.6-1.6,1.6Z",
    fill: "#d25a5a"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1869.9,728.6c-.9,0-1.6-.7-1.6-1.6v-14.1c0-.9.7-1.6,1.6-1.6s1.6.7,1.6,1.6v14.1c0,.9-.7,1.6-1.6,1.6Z",
    fill: "#d25a5a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1876.9,721.6h-14.1c-.9,0-1.6-.8-1.6-1.7s.7-1.6,1.6-1.6h14.1c.9,0,1.7.7,1.7,1.6s-.8,1.7-1.7,1.7Z",
    fill: "#d25a5a"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1754.7,648.1c0,3.1-2.5,5.7-5.7,5.7-3.1,0-5.7-2.6-5.7-5.7c0-3.2,2.6-5.7,5.7-5.7c3.2,0,5.7,2.5,5.7,5.7Z",
    fill: "#ffcf83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1969,689.4c0,3.1-2.5,5.7-5.7,5.7-3.1,0-5.7-2.6-5.7-5.7c0-3.2,2.6-5.7,5.7-5.7c3.2,0,5.7,2.5,5.7,5.7Z",
    fill: "#a8c7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795.9,707.5c0,2.1-1.7,3.8-3.8,3.8s-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8Z",
    fill: "#d25a5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1648.4,716.7c0,2.1-1.7,3.8-3.8,3.8s-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8Z",
    fill: "#a8c7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2077.6,694.4c0,2.1-1.7,3.8-3.8,3.8s-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8Z",
    fill: "#a8c7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1889.9,670.4c0,2.1-1.7,3.8-3.8,3.8-2,0-3.7-1.7-3.7-3.8s1.7-3.8,3.7-3.8c2.1,0,3.8,1.7,3.8,3.8Z",
    fill: "#a8c7bf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2023.7,716.7c0,2.1-1.7,3.8-3.8,3.8s-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8Z",
    fill: "#ffcf83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1941.3,632.8c0,2.1-1.7,3.8-3.8,3.8s-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8Z",
    fill: "#ffcf83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2078.5,940.7c-4.8,1-10.5-1.2-13.9.1-2.3.8-4,5.6-4,5.6s-4.9,1.7-5.2,4.1c-.2,2.5,1.8,3.9,1.8,3.9s-1.3,1.9-.7,3.8c.6,1.6,3.8,2.8,3.8,2.8s-.1,2.2,1.9,3.7c1.2.9,6.4.4,10.9-1.1c5.2-1.7,10-4.7,12.1-5.9c4.6-2.7-2.9-17.9-6.7-17Z",
    fill: "url(#es3kTfY9O2J202-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2057.2,955.1c-.3,0-.6-.2-.7-.6s.2-.8.6-.9c0,0,2.1-.4,3.2-1c.4-.2.8,0,1,.4.2.3,0,.8-.3,1-1.3.6-3.5,1.1-3.6,1.1q-.1,0-.2,0Z",
    fill: "url(#es3kTfY9O2J204-fill)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2060.3,961.8c-.3,0-.7-.3-.7-.7s.3-.8.7-.8c0,0,1.9-.2,3.4-.9.4-.1.8,0,1,.4.1.4,0,.8-.4,1-1.8.8-3.8,1-3.9,1q0,0-.1,0Z",
    fill: "url(#es3kTfY9O2J206-fill)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2078.5,940.7c3.8-1.1,11.4-10.2,11.4-10.2l16.3,16.5c0,0-9,6.4-21,10.7l-6.7-17Z",
    fill: "url(#es3kTfY9O2J207-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2077.6,838.3c36.2,16.7,74.5,40.3,77,57.9c3.3,23.1-46.2,60-58.6,56.4-9.1-2.7-13.5-11.1-14-16.5-.7-5.8,24.8-29.7,24.8-29.7s-36.2-9.3-42.9-15.3c-6.8-6-7-50,13.7-52.8Z",
    fill: "#a8c7bf"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2106.8,907.2q-.2,0-.4-.1c-.3-.1-.5-.5-.4-.9.1-.3,1.9-9.2,8.6-14.4.4-.3.9-.3,1.1.1.3.4.3.9-.1,1.1-3.8,3.1-5.9,7.4-7,10.4c3.4-3.3,10.3-8.8,18.9-10.2.4,0,.8.3.9.7s-.2.9-.7.9c-11.5,1.9-20.2,12-20.3,12.1-.1.2-.4.3-.6.3Z",
    fill: "#90b3ad"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2106.8,907.2q-.1,0-.3,0c-.2-.1-26.4-8.5-38.5-12-7.6-2.2-13.4-4.4-13.5-4.4-.4-.1-.6-.6-.4-1c.1-.5.6-.7,1-.5.1,0,5.9,2.2,13.3,4.3c12.2,3.5,38.4,11.9,38.6,12c.5.2.7.6.6,1s-.5.6-.8.6Z",
    fill: "#90b3ad"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2059.7,896.4c-2,0-3.4-.1-3.5-.1-.5-.1-.8-.5-.7-.9c0-.5.4-.8.8-.7.1,0,7.1.6,11.6-1.1.4-.1.9.1,1.1.5.1.4-.1.9-.5,1.1-2.7,1-6.2,1.2-8.8,1.2Z",
    fill: "#90b3ad"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2063.4,968.9q-.1,0-.2,0c-3.8-.9-7.3-3.6-10-7.6-2.4-3.5-3.8-7.5-5.2-11.4-.1-.4.1-.9.5-1c.4-.2.9.1,1,.5c1.4,3.7,2.8,7.6,5,11c2.5,3.6,5.7,6.1,9.1,6.9.5.1.7.5.6,1-.1.3-.4.6-.8.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2056.6,969q-.2,0-.3-.1c-2.6-1.3-4.7-3.3-6.2-5.8-.2-.3-.1-.8.3-1.1.4-.2.9-.1,1.1.3c1.3,2.2,3.3,4,5.5,5.1.4.2.6.7.4,1.1-.2.3-.5.5-.8.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2098.1,953.7q-1.3,0-2.3-.3c-9.7-2.8-14.1-11.9-14.6-17.3-.1-.4.2-.8.7-.8.4-.1.8.2.9.7.5,4.9,4.5,13.2,13.5,15.8c5.6,1.7,20.4-6,33.7-17.5c15.6-13.5,24.1-27.4,22.7-37.3c0-.4.3-.8.7-.9.4,0,.9.3.9.7c1.5,10.4-7.2,24.9-23.3,38.7-10.9,9.5-25,18.2-32.9,18.2Z",
    fill: "#90b3ad"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2000.7,879.3q-.1,0-.2,0c-.4-.1-.7-.5-.6-1c.5-1.8,1-4,1.5-6.3c2.9-12.7,7-30.2,10.5-36.9.2-.4.7-.6,1.1-.4s.5.7.3,1.1c-3.4,6.6-7.4,23.9-10.3,36.6-.6,2.3-1.1,4.4-1.5,6.3-.1.4-.4.6-.8.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2019.7,882.4q-.1,0-.2-.1c-.5-.1-.7-.5-.6-.9c1.2-5.2,1.5-11.2,1.9-17.6.5-9,1-18.4,4.1-26.3.2-.4.6-.6,1.1-.4.4.1.6.6.4,1-3,7.7-3.5,16.9-4,25.8-.3,6.5-.7,12.6-2,17.8c0,.4-.4.7-.7.7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2044.3,837.9c-.3,0-.6-.3-.7-.6c0-.4.2-.7.6-.8c6.2-.9,12.2-3.2,17.4-6.6.3-.2.7-.1.9.2s.2.8-.2,1c-5.3,3.5-11.5,5.9-17.9,6.8q0,0-.1,0Z",
    fill: "#d4bfb9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2053.7,830.9c-.3,0-.6-.2-.6-.5-.1-.4.1-.8.5-.9c2.4-.6,4.6-1.6,6.6-3.1.4-.2.8-.1,1,.2s.2.8-.1,1c-2.2,1.5-4.6,2.6-7.2,3.3q-.1,0-.2,0Z",
    fill: "#d4bfb9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2006.9,834.7q-.1,0-.2,0c-3.4-1.1-6.6-3.2-8.8-6-.3-.3-.3-.8,0-1s.8-.2,1,.1c2.2,2.6,5.1,4.5,8.2,5.5.4.2.6.6.5.9s-.4.5-.7.5Z",
    fill: "#d4bfb9"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1905.5,797.8q-.3,0-.5-.3c-.3-.2-.2-.7,0-.9c5.6-4.7,13-7.3,20.4-7.2q1.4.1,2.9.2c1.5.1,3.2.2,4.7.1c2-.2,4.8-.8,6.5-2.8.3-.2.7-.3,1,0c.2.2.3.6,0,.9-2,2.3-5.1,3-7.4,3.2-1.6.1-3.3,0-4.9-.1q-1.4-.1-2.9-.2c-6.9-.1-14.1,2.4-19.4,6.9q-.2.2-.4.2Z",
    fill: "#a74f49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1934.1,787.1c-.4,0-.6-.2-.7-.5c0-.4.2-.7.6-.8c2.1-.3,4.2-1.3,5.8-2.7.2-.3.6-.2.9,0c.2.3.2.7-.1,1-1.8,1.6-4.1,2.6-6.4,3q-.1,0-.1,0Z",
    fill: "#a74f49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1958,808.8c-4.1,0-8.2-1.6-11.2-4.5-3.8-3.6-5.6-9.1-4.7-14.3c0-.4.4-.6.7-.6.4.1.6.4.5.8-.8,4.8.9,9.8,4.4,13.2c3.5,3.3,8.6,4.8,13.3,3.8.4-.1.7.1.8.5.1.3-.1.7-.5.7q-1.6.4-3.3.4Z",
    fill: "#a74f49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1955.8,813.1c-2.8,0-5.6-1.3-7.4-3.4-.2-.3-.2-.7.1-1c.2-.2.7-.2.9.1c2.1,2.5,5.8,3.6,8.9,2.6.3-.2.7,0,.8.4.1.3-.1.7-.4.8q-1.5.5-2.9.5Z",
    fill: "#a74f49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1960.9,791.6c-.3,0-.6-.2-.6-.4-1.4-3.8-3.9-7.1-7.3-9.4-3.3-2.2-7.3-3.3-11.3-3.2-.4.1-.7-.2-.7-.6c0-.3.3-.6.6-.7c4.3-.1,8.6,1.1,12.2,3.5c3.5,2.4,6.3,5.9,7.7,9.9.1.4-.1.8-.4.9q-.1,0-.2,0Z",
    fill: "#a74f49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1936.9,778.4q-.2,0-.4-.1c-2.9-2.2-7.1-2.9-10.6-1.6-.3.1-.7,0-.8-.4-.1-.3.1-.7.4-.8c3.9-1.4,8.5-.7,11.8,1.8.3.2.4.6.2.9-.2.2-.4.2-.6.2Z",
    fill: "#a74f49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1975.2,846.2c-.2,0-.5-.2-.6-.4-1-2.2-3.6-3.2-5-3.6-1.2-.3-2.4-.5-3.6-.7-1.1-.1-2.1-.3-3.1-.5-4.8-1.1-9.1-4.1-11.9-8-.2-.3-.1-.7.2-1c.3-.2.7-.1.9.2c2.6,3.7,6.7,6.5,11.1,7.5c1,.2,2,.4,3,.5c1.2.2,2.5.4,3.8.8c2.8.8,4.8,2.3,5.8,4.2.2.4,0,.8-.3.9q-.1.1-.3.1Z",
    fill: "#a74f49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1972.5,858.5q-.2,0-.4-.1c-.3-.2-.4-.6-.2-.9c1-1.6,1.3-3.5,1-5.3-.4-1.9-1.4-3.6-2.9-4.7-.3-.2-.3-.6-.1-.9s.6-.3.9-.1c1.7,1.3,3,3.3,3.4,5.4s0,4.4-1.2,6.3c-.1.2-.3.3-.5.3Z",
    fill: "#a74f49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1956.2,845.3q-.1,0-.3-.1c-4.8-2.3-8.7-6.7-10.2-11.9-.1-.3.1-.7.4-.8s.7.1.8.4c1.5,4.9,5,9,9.6,11.1.3.2.5.6.3.9-.1.3-.3.4-.6.4Z",
    fill: "#a74f49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1959.9,852.9q-.1,0-.2,0c-4.7-1.1-8.9-4.3-11.3-8.5-.2-.3-.1-.7.2-.9.4-.2.8,0,.9.3c2.2,3.9,6.2,6.8,10.5,7.8.4.1.6.4.5.8-.1.3-.3.5-.6.5Z",
    fill: "#a74f49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1967.2,859.8c-.2,0-.4,0-.6-.2-.2-.3-.1-.7.2-.9c1.5-1.1,2.2-3.2,1.7-5-.1-.3.1-.7.4-.8s.7.1.8.4c.7,2.4-.2,5-2.1,6.4q-.2.1-.4.1Z",
    fill: "#a74f49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1976.4,875.9c-.3,0-.5-.2-.6-.4-.2-.3,0-.7.3-.9.2-.1.8-1,1.3-2.8.9-3.5.9-8.8-1.8-13-.2-.3-.1-.7.2-.9s.7-.1.9.2c3.1,4.8,3,10.7,1.8,14.6-.3,1-1,2.7-1.9,3.1q-.1.1-.2.1Z",
    fill: "#a74f49"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1975.1,867.4q0,0-.1,0c-.3-.1-.6-.4-.5-.8.3-1.8-.3-3.8-1.4-5.3-.2-.2-.1-.6.1-.9.3-.2.7-.1,1,.2c1.3,1.7,1.9,4,1.6,6.2-.1.4-.4.6-.7.6Z",
    fill: "#a74f49"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1886.5,973.1q0,0-.1,0c-.4-.1-.8-.5-.7-.9c0-.3,4-30.2,3.3-36.5-.3-2.4-1.6-6-3.1-10.2-2.4-6.7-5.5-15.1-5.6-22.8-.1-2,1.1-7,3.8-15.9.2-.4.6-.7,1-.5.5.1.7.5.6,1-1.7,5.4-3.9,12.9-3.8,15.4.2,7.4,3.1,15.6,5.5,22.2c1.6,4.3,2.9,8,3.2,10.6.7,6.6-3.1,35.7-3.3,36.9c0,.4-.4.7-.8.7Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1881.5,898.1c-.4,0-.7-.2-.8-.6-1.1-3.6-.6-8.3-.6-8.4.1-.5.5-.8.9-.8.5.1.8.5.8.9c0,.1-.6,4.5.5,7.8.1.5-.1.9-.6,1.1q-.1,0-.2,0Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1860.3,950.3q-.3,0-.7,0c-18.1-1.1-32.7-26.2-44.6-76.7c0-.3,0-.5.2-.7.4-.4,8.9-9.2,19.6-10.5.3,0,.5.1.7.4l4.4,6.2c.1.2.1.5.1.8-.1.2-.3.4-.6.5-.1,0-12.8,3.9-20.7,11.6q0,0,0,0c11.2,43.3,24.9,65.8,41,66.7c9,.6,22.1-10.5,29.1-17.1.3-.3.8-.3,1.1,0c.3.4.3.9,0,1.2-7,6.6-20,17.6-29.6,17.6Zm-43.6-76.6q.8,3.2,1.6,6.4c6.9-6.3,16.4-10,19.6-11l-3.4-5c-8.8,1.3-16.2,8-17.8,9.6Z",
    fill: "#544548",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1821,879.1c-.3,0-.6-.2-.8-.6l-2.1-7c-.2-.4.1-.9.5-1c.4-.2.9.1,1,.5l2.2,7.1c.1.4-.1.8-.5,1q-.2,0-.3,0Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1825.1,876.3c-.3,0-.6-.2-.8-.5l-2.5-6.6c-.2-.4,0-.8.4-1s.9,0,1.1.4l2.5,6.6c.2.4,0,.8-.4,1q-.2.1-.3.1Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1831.9,872.9c-.3,0-.6-.2-.8-.5l-3.3-6.3c-.3-.4-.1-.9.3-1.1s.9-.1,1.1.3l3.4,6.4c.2.4,0,.9-.4,1.1q-.1.1-.3.1Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1834.6,871.7c-.3,0-.6-.2-.7-.4l-3.6-6.1c-.2-.4,0-.9.3-1.2.4-.2.9-.1,1.2.3l3.5,6.1c.2.4.1.9-.3,1.1q-.2.2-.4.2Z",
    fill: "#544548"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1867.5,921.2c-.4,0-.7-.3-.8-.7c0-.1-1.1-9.5-6.3-14.7-.2-.2-.3-.6-.1-.9.1-.3.4-.5.7-.5.2,0,5.5.1,9.2,7.8.2.4,0,.9-.4,1.1s-.9,0-1.1-.4c-1.7-3.6-3.8-5.3-5.3-6.1c4,5.6,4.9,13.2,4.9,13.5.1.5-.2.9-.7.9q0,0-.1,0Z",
    fill: "#786468"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1973.8,973.5c-.4,0-.7-.3-.8-.7c0-.4-8-41.2-27.5-74-.3-.4-.1-.9.3-1.1.3-.3.8-.1,1.1.3c19.6,33,27.6,74.1,27.7,74.5.1.5-.2.9-.6,1q-.1,0-.2,0Z",
    fill: "#544548"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1950.9,907.9q-.2,0-.4-.2l-6.3-4c-.3-.3-.4-.8-.2-1.2.2-.3.7-.4,1.1-.2l6.3,4.1c.3.2.4.7.2,1.1-.2.2-.4.4-.7.4Z",
    fill: "#786468"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1918.1,924.5q-.2,0-.3,0c-4.8-2.1-8.9-5.7-11.6-10.2-.2-.3-.1-.8.3-1.1.4-.2.9-.1,1.1.3c2.5,4.2,6.3,7.6,10.8,9.5.4.1.6.6.5,1-.2.3-.5.5-.8.5Z",
    fill: "#786468"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1913.8,926.3q-.2,0-.3,0c-2.6-.8-4.9-2.4-6.5-4.7-.3-.4-.2-.9.2-1.1.4-.3.9-.2,1.1.2c1.4,1.9,3.4,3.4,5.7,4c.4.2.7.6.5,1-.1.4-.4.6-.7.6Z",
    fill: "#786468"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2017.5,903.1q-.1,0-.2,0c-5.6-1.5-15.5-8.8-18.3-14.4-.2-.4-.1-.8.3-1c.3-.2.7,0,.9.3c2.7,5.4,12.1,12.3,17.5,13.8.4.1.6.5.5.8s-.4.5-.7.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2010.1,904.7q-.1,0-.2-.1c-3.2-1.1-6.2-3.2-8.3-5.9-.2-.3-.2-.7.1-1c.3-.2.8-.2,1,.1c2,2.5,4.7,4.4,7.6,5.5.4.1.6.5.5.9-.1.3-.4.5-.7.5Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1803.8,807.5c0,0,6.9,4.6,5.4,14.5-1.8,11.7-8.5,18.3-8.5,18.3l16.5,2.8c0,0-3.4-10.2-1.9-19.9s9.3-12.3,9.3-12.3l-20.8-3.4Z",
    fill: "#ffb86b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1782.4,848.4l50.3,7.8c0,0-6.4-12.4-22.4-15.5-16.8-3.3-27.9,7.7-27.9,7.7Z",
    fill: "#ffcf83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1797.2,736.8l57.9,9c0,0-.2,70-39.7,65.7-39.6-4.4-18.2-74.7-18.2-74.7Z",
    fill: "#ffcf83"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1788.5,799.6c-2.6,0-5.7-.5-9.3-2-8.3-3.3-15.8-14.7-17.8-27.1-1.7-10.5,1-19.7,7.4-25.1c12-10.2,23.6-3.4,28.1,1.7c1,1.1.9,2.8-.2,3.7-1.1,1-2.8.9-3.8-.2s-9.8-10.4-20.6-1.2c-6.8,5.8-6.4,15.2-5.6,20.3c1.7,10.4,7.9,20.3,14.5,23c9.4,3.8,14.2-.5,14.2-.6c1.1-1,2.8-1,3.8.1s1,2.7-.1,3.8c-.2.2-3.8,3.6-10.6,3.6Z",
    fill: "#ffcf83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1851.4,810.2c-11,0-15.1-6.8-15.3-7.1-.8-1.3-.3-2.9.9-3.6c1.3-.8,2.9-.4,3.7.9.1.2,3.5,5.5,13.6,4.3c6.8-.9,15-7.9,19.4-16.8c2.4-4.8,5.6-14.1.4-22.8-2.1-3.6-4.9-5.8-8.1-6.6-5.9-1.4-11.9,2.4-12,2.5-1.2.8-2.8.4-3.7-.8-.8-1.2-.4-2.9.8-3.7.3-.2,7.9-5.1,16.1-3.2c4.7,1.1,8.6,4.2,11.5,9.1c4.7,8,4.6,18.1-.2,27.9-5.2,10.5-14.9,18.6-23.6,19.7q-1.9.2-3.5.2Z",
    fill: "#ffcf83"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1855.1,745.8l-13.5-2.1c-.6,11.1-5,65.9-34.5,62.6-2.6-.2-5-1-7-2c3.6,3.8,8.6,6.4,15.3,7.2c39.5,4.3,39.7-65.7,39.7-65.7Z",
    fill: "#ffb86b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1810.3,840.7q-1.7-.3-3.3-.5c8.8,1.8,13.8,14.2,13.8,14.2l11.9,1.8c0,0-6.4-12.4-22.4-15.5Z",
    fill: "#ffb86b"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1834.3,747.7q-.1,0-.1,0l-33.4-5.2c-.6,0-1-.6-.9-1.1.1-.6.6-.9,1.2-.8l33.4,5.1c.5.1.9.6.8,1.2-.1.5-.5.8-1,.8Z",
    fill: "#ffedd1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1815,748.8q0,0-.1,0l-12.5-2c-.6-.1-1-.6-.9-1.1.1-.6.6-.9,1.2-.8l12.5,1.9c.5.1.9.6.8,1.1s-.5.9-1,.9Z",
    fill: "#ffedd1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1804.8,803.4q-.3,0-.5-.1c-9.7-5.7-9-28.5-8.9-29.4c0-.6.5-1,1-1c.6,0,1,.5,1,1.1c0,.2-.8,22.5,7.9,27.6.5.3.6.9.3,1.4-.1.3-.5.4-.8.4Z",
    fill: "#ffedd1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1808.4,849.9q-.1,0-.1,0l-16.1-2.5c-.5-.1-.9-.6-.8-1.1.1-.6.6-1,1.1-.9l16.1,2.5c.5.1.9.6.8,1.2-.1.4-.5.8-1,.8Z",
    fill: "#ffedd1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1764.8,756.5q-.2,0-.3,0c-.5-.2-.8-.7-.7-1.3.2-.4,3.7-11.7,15.4-13c.5-.1,1,.3,1.1.8.1.6-.3,1.1-.9,1.1-10.3,1.3-13.5,11.3-13.7,11.7-.1.5-.5.7-.9.7Z",
    fill: "#ffedd1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1791.1,746.7q-.3,0-.6-.3c-1.7-1.4-5.1-2.1-6.2-2.3-.6-.1-1-.6-.9-1.1.1-.6.6-1,1.2-.9.2,0,4.7.8,7.2,2.8.4.3.4,1,.1,1.4-.2.2-.5.4-.8.4Z",
    fill: "#ffedd1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1874.3,761.7c-.3,0-.6-.1-.8-.4-4.6-6.1-12.1-4.9-12.2-4.9-.5.1-1-.2-1.1-.8-.1-.5.2-1,.8-1.1.3-.1,8.8-1.5,14.1,5.6.4.4.3,1.1-.2,1.4q-.2.2-.6.2Z",
    fill: "#ffedd1"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M1792,855c-3.9-3.1-8.1-7.1-6.1-8.3s3.9,1.1,7.6,3.8s7.2,3.9,7.2,3.9L1797,857l-5-2Z",
    fill: "url(#es3kTfY9O2J313-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1891.4,788.1c-2.3-3.2-5.2-9.4-8.7-12-2.8-2.2-10.9-2.7-11,0-.1,2.6,5,3.3,7.2,5.3c3.8,3.3.2,12.3,6.4,16.2c6.9,4.3,8.3-6.4,6.1-9.5Z",
    fill: "url(#es3kTfY9O2J314-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1870.1,780.8c1-1.5,3.9-1.7,7.4.4c4.9,2.8,5.3,6.4,4.1,7.1-1.1.7-3.7-1.2-6.5-2.5-2.3-1-6.6-2.5-5-5Z",
    fill: "url(#es3kTfY9O2J315-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1866.3,788.8c1.3-2,3.2-.8,6.2,1.4c3.8,2.7,4.8,5.6,3.8,6.3-1,.6-3.3-.3-5.3-1.4-2-1.2-6.3-4-4.7-6.3Z",
    fill: "url(#es3kTfY9O2J316-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1867.9,784.3c1-1.5,3.6-.8,7.2,1.5c4.9,3.2,5.5,6.2,4.5,7.2-1.1,1.1-4.6-.7-7.4-2.6-2.2-1.5-5.9-3.6-4.3-6.1Z",
    fill: "url(#es3kTfY9O2J317-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1738.5,800.6c0,0,12.1-16.1,19-20.5c7-4.5,16.5-3.8,18.8-2c2.2,1.7,1.4,3.2,1.4,3.2s2.7.7,3,2.7c.5,2.3-1.9,3.5-1.9,3.5s1.6,1,1.4,2.5c-.3,2.1-3.7,3.5-7.3,5-5.5,2.2-7.3,1.7-9.9,3.4c0,0-6,5.5-9.8,11.6l-14.7-9.4Z",
    fill: "url(#es3kTfY9O2J318-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1873.5,791.4q-.2,0-.4-.1c-2-1.6-4.4-2.7-4.4-2.7-.3-.2-.5-.5-.3-.9.1-.3.5-.4.8-.3.1.1,2.6,1.2,4.7,2.9.3.2.3.6.1.9q-.2.2-.5.2Z",
    fill: "url(#es3kTfY9O2J320-fill)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1875.6,786.7q-.2,0-.4-.1c-1.3-.8-4.2-2.1-4.2-2.1-.3-.1-.5-.5-.4-.8.2-.3.6-.5.9-.4.1.1,3,1.3,4.4,2.3.3.2.4.6.2.9-.1.1-.3.2-.5.2Z",
    fill: "url(#es3kTfY9O2J322-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1739.9,792.3c0,0,13,3.7,18.4,18.2c0,0-22.4,81-53.5,94.4s-64.4-11.2-64.4-11.2c4.3-24.6,13.4-37.6,25.4-43.6l23.8,8.9c0,0,37.7-55.3,50.3-66.7Z",
    fill: "url(#es3kTfY9O2J323-fill)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1682.8,910.5c-19.8,0-33.4-10.9-33.5-11-.4-.4-.5-1-.2-1.4.4-.4,1-.4,1.4-.1.2.2,23.8,19,53.9,6c22.8-9.8,41.1-57.1,48.9-80.6q-.2-.1-.3-.4c-4.4-12.5-19.5-21.3-19.6-21.4-.3-.2-.5-.4-.5-.7s0-.6.2-.8l6.8-7.8c.2-.3.6-.4,1-.3.5.1,12.8,3.4,18.3,18.2q.1.3.1.6c-1,3.3-22.9,81.5-54.1,95-8,3.4-15.5,4.7-22.4,4.7Zm52.5-110c3.4,2.1,14.3,9.7,18.9,20.3c1.7-5.4,2.8-9.2,3.1-10.2-4.6-11.9-14-15.8-16.4-16.6l-5.6,6.5Z",
    fill: "#bc4d4d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1777.7,782q-.1,0-.1-.1c0,0-1.6-.1-3,0-.4,0-.7-.3-.7-.6c0-.4.2-.7.6-.7c1.5-.1,3.2.1,3.2.1.4,0,.7.3.6.7c0,.3-.3.6-.6.6Z",
    fill: "url(#es3kTfY9O2J327-fill)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1778.4,788q0,0-.1,0c0,0-1.6-.2-3-.1-.4,0-.7-.2-.7-.6c0-.3.2-.6.6-.7c1.6-.1,3.2.1,3.3.1.3.1.6.4.5.7c0,.4-.3.6-.6.6Z",
    fill: "url(#es3kTfY9O2J329-fill)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1657.6,907.9c-3.5,0-6.1-1-6.3-1-.5-.2-.7-.8-.5-1.3s.7-.7,1.2-.5c0,0,5.2,1.8,10.2.1.5-.1,1.1.1,1.2.6.2.5-.1,1.1-.6,1.2-1.8.7-3.6.9-5.2.9Z",
    fill: "#bc4d4d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1739.3,978.9c-.6,0-1-.5-1-1c0-.2,0-21.1-.4-36.8-.2-7.6.4-14.3,1.1-21.3.7-7.8,1.6-16.5,1.4-27.9c0-.5.4-1,.9-1c.6,0,1,.4,1,.9.2,11.5-.7,20.4-1.4,28.2-.7,6.9-1.3,13.5-1.1,21c.4,15.7.4,36.7.4,36.9c0,.5-.4,1-.9,1Z",
    fill: "#bc4d4d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1741.3,908.7q-.2,0-.4-.1c-.4-.2-.6-.8-.4-1.2c0-.1,3.5-7.5,3.9-12c0-.5.4-.9,1-.9.5.1.9.5.9,1.1-.4,4.8-4,12.3-4.1,12.6-.2.3-.5.5-.9.5Z",
    fill: "#bc4d4d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1722.3,918.8c.4-.4,1-.5,1.4-.2.4.4.4,1,.1,1.4-3.9,4.7-8.4,8.9-13.5,12.4q-.2.2-.5.2c-.3,0-.6-.2-.8-.5-.3-.4-.2-1,.3-1.3",
    fill: "#ffe5d7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1713.5,936.7c-.4,0-.8-.2-.9-.6-.2-.5.1-1,.6-1.2c3-1.2,5.6-3.6,7-6.6.2-.5.8-.7,1.2-.4.5.2.7.7.5,1.2-1.6,3.5-4.5,6.2-8.1,7.6q-.1,0-.3,0Z",
    fill: "#ffe5d7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1682,876.5c-.5,0-.9-.3-.9-.9-.3-5.6,2.3-10.4,4.6-13.6-2,1.4-4.4,3.6-6.1,7-.2.4-.8.6-1.2.4-.5-.2-.7-.8-.5-1.3c4-7.9,11.2-9.9,11.5-10c.4-.1.9.1,1.1.5s.1.9-.2,1.2c-.1,0-7.8,7.1-7.3,15.7c0,.6-.4,1-.9,1q0,0-.1,0Z",
    fill: "#bc4d4d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1703.4,898.6c-.5,0-.8-.3-1-.7-.1-.5.2-1.1.7-1.2c4.1-1.1,7.7-4,9.6-7.8.2-.5.8-.7,1.2-.4.5.2.7.8.5,1.3-2.1,4.3-6.2,7.5-10.8,8.7q-.1.1-.2.1Z",
    fill: "#ffe5d7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1739.3,804.7q-.4,0-.6-.2c-.5-.4-.5-1-.2-1.4l6.5-7.8c.4-.4,1-.5,1.4-.2.4.4.4,1,.1,1.4l-6.5,7.8c-.2.3-.5.4-.7.4Z",
    fill: "#bc4d4d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1742.8,807.7q-.3,0-.6-.2c-.4-.3-.5-.9-.2-1.3l6-8.7c.3-.4.9-.5,1.3-.3.4.3.5.9.2,1.4l-5.9,8.7c-.2.2-.5.4-.8.4Z",
    fill: "#bc4d4d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1750.6,816.3q-.1,0-.3,0c-.5-.3-.7-.8-.5-1.3l4.6-10.3c.2-.5.8-.7,1.2-.5.5.2.7.8.5,1.3l-4.6,10.3c-.1.3-.5.5-.9.5Z",
    fill: "#bc4d4d"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills10);
export default __webpack_public_path__ + "static/media/skills10.5dc3afc09c349d6f2c6ece9483482297.svg";
export { ForwardRef as ReactComponent };